import React, {useCallback, useEffect, useRef, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {
  ModeleClientDemande,
  ModeleClientDemandePiece,
  ModeleClientOtherData,
  modeleClientOtherDataInitValues,
  modeleDemandePieceInitValues,
  ModeleEditCentre,
} from '../../../../components/Models'
import {useLocation, useNavigate} from 'react-router-dom'
import {
  deleteImmatOnEdit,
  editDemandes,
  getAllPieceTypePiece,
  getCatdata,
  getCentres,
  getClientAdresses,
  getClientDemandeImmat,
  getDemandeProposee,
  getOneVehicleModele,
  getSearchPieceRefConst,
  getSearchPieceTypePiece,
  getSiteVehiculeImmat,
  getTypePieceStockValue,
  postDemandes,
  postGenreByCode,
} from '../../../../components/requests'
import {SelectInput} from '../../../../components/inputs/SelectInput'
import Swal from 'sweetalert2'
import moment from 'moment/moment'
import {
  formatTypePiecePourDemande,
  shouldDisplayFonctionnalite,
} from '../../../../components/helpers'
import {AutoCompleteRefConst} from '../../../../components/AutoCompleteRefConst'
import {LoadingData} from '../../../../components/LoadingData'
import VehicleData from './VehicleData'
import {toast} from 'react-toastify'
import {Tooltip} from 'react-tooltip'
import ResearchVehicleModal from './ResearchVehicleModal'
import {SearchPiece} from '../../../../components/SearchPiece'
import {TransfertCentreModal} from '../TransfertCentreModal'
import {TransfertCentreHnModal} from '../TransfertCentreHnModal'
import {useAuth} from '../../../modules/auth'
import ClientInfos from './ClientInfos'
import AdresseClient from './Televendeur/AdresseClient'
import {KTIcon} from '../../../../_metronic/helpers'
import {copyText} from '../../../../components/renders'
import ResearchClientModal from './ResearchClientModal'
import ChoixContactModal from './ChoixContactModal'
import AddClientModal from './AddClientModal'
import ClientMoreInfos from './Televendeur/ClientMoreInfos'
import EquipeModal from './EquipeModal'
import ClientAdresseFormModal from '../../shop/clients/components/ClientAdresseFormModal'
import {useFilAriane} from '../../../contexts/FilArianeContext'
import {usePanier} from '../pages/Televendeur/PanierContext'
import DemandePj from './DemandePj'
import {FileWithPreview} from '../../../../components/MutliFilePicker'
import {Modal} from "bootstrap";

const clientDemandeSchema = Yup.object().shape({
  commentaire: Yup.string().notRequired(),
})

const API_URL = process.env.REACT_APP_API_URL
const demandePj_url = `${API_URL}/uploads/demandePJ/`

const DemandeForm = (props) => {
  const {
    idClient,
    isProfessionnel,
    redirectToClientDemande,
    handleImmatValide,
    contactedBy,
    loadingDataCLient,
    setLoadingDataCLient,
    filters,
    immatValide,
    fromTraitement,
    isFromClient,
    choicedDemandeSource,
    isClientSocietyDemande,
    defaultValueContactDemande,
    contentCommunicationDemande,
    isDuplicateDemande,
    radioValueDemande,
    handleUpdateClientData,
    isConfirmEdit,
    setIsConfirmEdit,
    clientDemandeStatus,
  } = props
  const navigate = useNavigate()
  const [demandeId] = useState(props.demandeId)
  const userConnected = useAuth()
  const {currentUser} = useAuth()
  const [immatriculationValide, setImmatriculationValide] = useState(false)
  const [immatriculation, setImmatriculation] = useState<any>({})
  const [data] = useState<ModeleClientDemande>(props.data)
  const [pieces, setPieces] = useState<Array<ModeleClientDemandePiece>>([])
  const [loadStock, setLoadStock] = useState<boolean>(false)
  const [, setTempsEcoule] = useState<string | null>(null)
  const [suggestionsProduits] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [loadingOnSave, setLoadingOnSave] = useState(false)
  const [loadingOnSaveAndDupl, setLoadingOnSaveAndDupl] = useState(false)
  const [stockLoading, setStockLoading] = useState(false)
  const [loadingSearchRefConst, setLoadingSearchRefConst] = useState(false)
  const [resultShow, setResultShow] = useState<boolean>(false)
  const [resultShowPiece, setResultShowPiece] = useState<boolean>(false)
  const [centres, setCentres] = useState<Array<ModeleEditCentre>>([])
  const [currentPage] = useState<number>(1)
  const [searchPage] = useState<string>('')
  const [reloadVerif, setReloadVerif] = useState<boolean>(false)
  const [pieceCentreAssign, setPieceCentreAssign] = useState<any>({})
  const [selectedOptionHn, setSelectedOptionHn] = useState<any>('')
  const [selectedOption, setSelectedOption] = useState<any>('')
  const [idTypePieceEdit, setIdTypePieceEdit] = useState<any>(undefined)
  const [typePieceEditHn, setTypePieceEditHn] = useState<any>('')
  const [immatPieceEdit, setImmatPieceEdit] = useState<any>('')
  const piecesRef = useRef(pieces)
  const [immatAssignCentre, setImmatAssignCentre] = useState('')
  const [isTous, setIsTous] = useState<boolean>(true)
  const [isDeletable, setIsDeletable] = useState<boolean>(false)
  const [showMoreClientInfo, setShowMoreClientInfo] = useState<boolean>(false)
  const [disableInput, setDisableInput] = useState<boolean>(false)
  const [clientDemande, setClientDemande] = useState<any>(null)
  const [demandeSourceValue, setDemandeSourceValue] = useState<any>('')
  const [showDetailVehicule, setShowDetailVehicule] = useState(false)
  const [dataClient, setDataClient] = useState<any>([])
  const [clientAdresses, setClientAdresses] = useState<any>()
  const [otherData, setOtherData] = useState<ModeleClientOtherData>(modeleClientOtherDataInitValues)
  const [checkCopy, setCheckCopy] = useState<string | null>(null)
  const [updatedAdresseLivInfo, setUpdatedAdresseLivInfo] = useState({
    id: '',
    adresseLiv: '',
    complementAdresseLiv: '',
    telephoneLiv: '',
    cPLiv: '',
    villeLiv: '',
    paysLiv: '',
    edited: false,
  })
  const [updatedAdresseFactInfo, setUpdatedAdresseFactInfo] = useState({
    id: '',
    adresseFac: '',
    complementAdresseFac: '',
    telephoneFac: '',
    cPFac: '',
    villeFac: '',
    paysFac: '',
    edited: false,
  })
  const [isAdresseUpdated, setIsAdresseUpdated] = useState<boolean>(false)
  const refCentres = useRef<any>([])

  const [clientId, setClientId] = useState<number | null>(idClient)
  const [isClientSociety, setIsClientSociety] = useState<boolean>(isClientSocietyDemande)
  const [isDuplicate, setIsDuplicate] = useState<boolean>(isDuplicateDemande)
  const [radioValue, setRadioValue] = useState<string>(radioValueDemande ?? 'email')
  const [contentCommunication, setContentCommunication] = useState<any>(contentCommunicationDemande)
  const [contactedByDm, setContactedByDm] = useState<any | null>(contactedBy)
  const [defaultValueContact, setDefaultValueContact] = useState<any>(
    defaultValueContactDemande ?? ''
  )
  const [isEdit, setIsEdit] = useState<any>(false)
  const [openModalResVeh, setOpenModalResVeh] = useState<boolean>(false)
  const [isCreateViaModal, setIsCreateViaModal] = useState<boolean>(false)
  const [tempClientId, setTempClientId] = useState<number | null>(null)
  const [contactedByBloc, setContactedByBloc] = useState<string | null>(null)
  const [tempClient, setTempClient] = useState<any | null>(null)

  const [selectedEquipe, setSelectedEquipe] = useState<number | null>(null)
  const [isDuplicateButton, setIsDuplicateButton] = useState<boolean | null>(null)
  const verificationIsEdit = window?.location?.href?.includes('edit')
  const [isHovered, setIsHovered] = useState<boolean>(false)

  const [panierValue, setPanierValue] = useState<any>([])
  const [dataClientInfos, setDataClientInfos] = useState<any>([])

  const [images, setImages] = useState<FileWithPreview[]>([]) // PJ demande

  const {setStatut, setEtape, setPanierAriane, setDemandeAriane, resetFilAriane} = useFilAriane()

  // Setter la valeur de duplicate en false
  const toggleDuplicate = () => {
    setIsDuplicate(false)
  }

  // Charger les données clients passées de la liste
  useEffect(() => {
    setDataClient(props.dataClient)
    setOtherData(props.dataClientOther)
    // setLoadingDataCLient(false)
  }, [props.dataClient, props.dataClientOther])

  useEffect(() => {
    if (dataClient?.length && dataClient?.length > 0) setLoadingDataCLient(false)
  }, [dataClient])

  // gestion des immats sélectionnées
  const useImmatArray = () => {
    const [immatsArray, setImmatsArray] = useState<any>([])

    const addImmat = (newImmat) => {
      if (newImmat.id) {
        const centres = userConnected?.currentUser?.listeCentres?.[0] || []
        if (centres.length > 0) {
          if (!newImmat.isEdit) {
            if (newImmat?.centreId || newImmat?.centre) {
              setImmatSelected(newImmat.value)
              setImmatAssignCentre('')
              setIsTous(false)
              setDisableInput(false)
            } else {
              setImmatAssignCentre('')
            }
          }
        } else {
          if (immatSelected === '') {
            setIsTous(true)
          } else {
            setImmatSelected(newImmat.value)
            setIsTous(false)
            setDisableInput(false)
          }
        }
        // setImmatsArray((prevArray) => {
        //   const exists = prevArray.some((item) => item.id === newImmat.id)
        //
        //   if (exists) {
        //     return prevArray.map((item) => (item.id === newImmat.id ? newImmat : item))
        //   } else {
        //     return [...prevArray, newImmat]
        //   }
        // })
        setImmatsArray([newImmat])
      }
    }

    const editCentreImmat = (id: number, value: any) => {
      const immArrUpd = immatsArray.map((item) =>
        item.id === id ? {...item, centreLabel: value.label, centreId: value.id} : item
      )
      setImmatsArray(immArrUpd)
    }

    // Mise à jour lors de l'ajout de détails des véhicules hors type
    const updateVHT = (
      id: number,
      {label, marque, modele}: {label: string; marque: string; modele: string}
    ) => {
      setImmatsArray((prevI) =>
        prevI.map((i) => (i.id === id ? {...i, label: label + ' [VHT]', marque, modele} : i))
      )
      setDataImmatArr((prevD) =>
        prevD.map((d) =>
          d.id === id
            ? {...d, label, marque: {nom: marque}, modele: modele + ' [VHT]', nom: modele}
            : d
        )
      )
    }

    const deleteImmat = (
      e,
      DeletableOnEdit: boolean,
      immatToDelete: string,
      id: string,
      idClientDemande: number
    ) => {
      e.stopPropagation() //empêcher l'affichage de l'info véhicule au clique du td
      Swal.fire({
        title: 'Supprimer le véhicule ?',
        text: 'Cette action est irréversible.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, supprimer',
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
      }).then((result) => {
        if (result.isConfirmed) {
          if (DeletableOnEdit !== undefined) {
            const toastDeleteId = toast.loading('Suppression en cours...')
            deleteImmatOnEdit(idClientDemande).then((res) => {
              if (res?.status === 200) {
                setImmatsArray((prev) => prev.filter((immat) => immat.value !== immatToDelete))
                const newDataImmat = dataImmatArr.filter((d) => d.id !== id)
                setDataImmatArr(newDataImmat)
                if (newDataImmat.length > 0) {
                  const data = newDataImmat.pop()
                  setImmatriculation(data)
                  if (data?.marque || data?.smarque) {
                    setInfoModele([data])
                    supprimerVehicule(id)
                  } else {
                    setInfoModele([])
                  }
                }
                // Supprimer l'immat assignée à la pièce
                setImmatPieces((prevData) => {
                  const updatedData = {...prevData}
                  delete updatedData[immatToDelete]
                  return updatedData
                })
                // Supprimer les pièces associées dans pieces
                setPieces((prevPieces) =>
                  prevPieces.filter((piece) => piece.immat !== immatToDelete.toString())
                )
                setReloadVerif(true)
                supprimerImmat(immatToDelete)

                toast.update(toastDeleteId, {
                  render: 'Supprimé avec succès',
                  type: 'success',
                  isLoading: false,
                  autoClose: 3000,
                })
              } else {
                toast.update(toastDeleteId, {
                  render: 'Erreur lors de la suppression',
                  type: 'error',
                  isLoading: false,
                  autoClose: 3000,
                })
              }
            })
          } else {
            setImmatsArray((prev) => prev.filter((immat) => immat.value !== immatToDelete))
            const newDataImmat = dataImmatArr.filter((d) => d.id !== id)
            setDataImmatArr(newDataImmat)
            if (newDataImmat.length > 0) {
              const data = newDataImmat.pop()
              setImmatriculation(data)
              if (data?.marque || data?.smarque) {
                setInfoModele([data])
                supprimerVehicule(id)
              } else {
                setInfoModele([])
                // supprimerVehicule(id)
              }
            }
            // Supprimer l'immat assignée à la pièce
            setImmatPieces((prevData) => {
              const updatedData = {...prevData}
              delete updatedData[immatToDelete]
              return updatedData
            })
            // Supprimer les pièces associées dans pieces
            setPieces((prevPieces) =>
              prevPieces.filter((piece) => piece.immat !== immatToDelete.toString())
            )
            setReloadVerif(true)
            supprimerImmat(immatToDelete)
          }
        }
      })
    }
    return [immatsArray, addImmat, editCentreImmat, updateVHT, deleteImmat]
  }

  const [immatsArray, addImmat, editCentreImmat, updateVHT, deleteImmat] = useImmatArray()
  const [immatSelected, setImmatSelected] = useState('')
  const [siteSelected, setSiteSelected] = useState<string | null>(null)
  const [immatPieces, setImmatPieces] = useState<Record<string, ModeleClientDemande[]>>({})
  const [immatCentre, setImmatCentre] = useState<{[immatriculation: string]: string | null}>({})
  const [centre, setCentre] = useState<string | null>(null)
  const [centreLabel, setCentreLabel] = useState<string | null>(null)
  const [immat] = useState<string | null>(null)
  const [refConst, setRefConst] = useState<string>('')
  const [pieceRefConst, setPieceRefConst] = useState<Array<ModeleClientDemandePiece>>([])
  const [suggestion, setSuggestion] = useState<Array<string>>([])
  const [match, setMatch] = useState<Array<string> | null>([])
  const [pieceTypePiece, setPieceTypePiece] = useState<string>('')
  const [, setSpinner] = useState<boolean>(false)
  const location = useLocation()
  const lState = location.state as LocationState
  const [dataImmatArr, setDataImmatArr] = useState<any[]>([])
  const [dataImmatSelected, setDataImmatSelected] = useState<any>({})
  const [centreSelected, setCentreSelected] = useState<ModeleEditCentre>(
    props.centreSelected ?? {
      value: null,
      label: '',
    }
  )
  const clientDemandePath = `/vente/clients/${idClient}/afficher/demandClient/`
  const DemandeListPath = '/demandes/liste/'
  const demandeTraitement = `/demandes/${idClient}/traitement/${demandeId}`
  const [hover, setHover] = useState<number | null>(null)
  const toastId = useRef<any>(undefined)
  const [showNoPieceOnImmat, setShowNoPieceOnImmat] = useState<boolean>(false)
  const [pieceSpinner, setPieceSpinner] = useState<boolean>(false)
  const [vehicleInfo, setVehicleInfo] = useState<boolean>(false)
  const [infoModele, setInfoModele] = useState<any>([])
  const [infoModeleArr, setInfoModeleArr] = useState<any>([])
  const [modeleIdArr, setModeleIdArr] = useState<any>([])
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [clearInput, setClearInput] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState<string>('')
  const [vehicleAssignCentre, setVehicleAssignCentre] = useState<string | number>('')
  const immatsArrayRef = useRef(immatsArray)
  const [disableImmatSelect, setDisableImmatSelect] = useState<boolean>(false)
  const [dataHorsType, setDataHorsType] = useState<any>([])
  let allowAddCentre: boolean = lState?.allowAddCentre ?? false
  const immatPieceCallbackRef = useRef<
    ((updatedState: Record<string, ModeleClientDemande[]>) => void) | null
  >(null)
  const [searchTerm, setSearchTerm] = useState<string>(lState?.labelSearch ?? '')
  const [isPrevious, setIsPrevious] = useState<boolean>(true)
  const [retraitDepot, setRetraitDepot] = useState<boolean>(false)

  // Adresse de facturation / livraison > Création / Modification depuis Fiche client
  const [clientAdresseData, setClientAdresseData] = useState<any>(null)
  const [clientAdresseEdit, setClientAdresseEdit] = useState<any>(null)
  const [refetchClientData, setRefetchClientData] = useState<boolean>(false)
  const [livraisonSelectedValue, setLivraisonSelectedValue] = useState({value: '', label: ''})
  const [facturationSelectedValue, setFacturationSelectedValue] = useState({value: '', label: ''})

  interface LocationState {
    immat: any
    demandeId: number | undefined | null
    dataVehicle: any
    allowAddCentre: boolean
    defaultValueContact: any
    radioValue: string
    choicedDemandeSource: any
    immatValide: boolean
    isFromClient: boolean | undefined
    redirectToClientDemande: boolean | undefined
    withClientSearch: boolean | undefined
    contentCommunication: string
    labelSearch: string
  }

  useEffect(() => {
    if (lState?.choicedDemandeSource) {
      setDemandeSourceValue(lState?.choicedDemandeSource)
    }
  }, [lState?.choicedDemandeSource])

  // Revérification infos véhicule après suppression d'une immatriculation
  useEffect(() => {
    const lastImmat = immatsArray.at(-1)
    if (reloadVerif && lastImmat != undefined) {
      immatsArray.length != 0 && !lastImmat.value.includes('-') && verifyCatdata(lastImmat.value)
      immatSelected !== 'Tous' && setImmatSelected(lastImmat.value)
    }
  }, [reloadVerif, immatsArray])

  // Ne pas afficher l'info de l'immat s'il n'y en a pas
  useEffect(() => {
    immatsArray.length == 0 ? setVehicleInfo(true) : setVehicleInfo(false)
    immatsArrayRef.current = immatsArray
  }, [immatsArray])

  const supprimerVehicule = (vehiculeId: string) => {
    const prevState = lState || {dataVehicle: {}}

    if (!prevState.dataVehicle || !prevState.dataVehicle[vehiculeId]) {
      return
    }

    const dataVehicleMap = {...prevState.dataVehicle}
    delete dataVehicleMap[vehiculeId]

    navigate('.', {
      replace: true,
      state: {
        ...prevState,
        immat: prevState.immat ?? [], // ne change rien ici
        dataVehicle: dataVehicleMap,
      },
    })
  }

  // Récupération des données pour la modification d'une demande
  useEffect(() => {
    if (lState?.demandeId) {
      const toastLoader = toast.loading('Récupération des données en cours...')
      toastId.current = toastLoader

      let centreIds: string | undefined = ''
      if (userConnected) {
        let userCentre = userConnected?.currentUser?.listeCentres?.[0]
        if (userCentre?.length > 0) {
          centreIds = userCentre?.map((centre) => centre?.id)?.join(',')
        }
      }

      getClientDemandeImmat(lState.demandeId, centreIds)
        .then((response) => {
          if (response?.status == 200 && response?.data) {

            //get demandePJ
            const newFiles: any = Array.from(response?.data?.pjDemande ?? []).map((fileObjet:any) => ({
              id: crypto.randomUUID(), // Évite les bugs d'index lors des suppressions
              file: {
                name: fileObjet?.name,
                type: fileObjet?.type,
              },
              preview: `${demandePj_url}${fileObjet?.name}`, // url d'images demandePJ enrégistrer dans le projet
            }))
            setImages(newFiles)

            // Récupération des immats
            if (response.data.clientDemandeImmat?.length > 0) {
              const clientDemande = response.data.clientDemandeImmat.find(
                (p) => p.clientDemande.id == (lState.demandeId ?? demandeId)
              )
              setClientDemande(clientDemande?.clientDemande)
              setDataClientInfos(clientDemande?.clientDemande?.client)
              if (clientDemande?.clientDemande?.retraitDepot !== undefined) {
                setRetraitDepot(clientDemande?.clientDemande?.retraitDepot)
              }
              setDemandeSourceValue(clientDemande?.clientDemande?.demandeSource?.id ?? '')
              setSelectedEquipe(clientDemande?.clientDemande?.equipe?.id ?? null)
              // Définition de l'équipe si la demande en a
              // Pour ne pas afficher le modal de séléction d'une équipe
              setSelectedEquipe(clientDemande?.clientDemande?.equipe?.id ?? null)
              response.data.clientDemandeImmat?.map((di) => {
                //marque et modèle ajouter au label immatriculation
                let labelMarqMod = ''
                if (di?.donneesImmatriculation?.smarque) {
                  labelMarqMod = ' - ' + di?.donneesImmatriculation?.smarque ?? ''
                }
                if (di?.donneesImmatriculation?.smodele) {
                  labelMarqMod += ' - ' + di?.donneesImmatriculation?.smodele ?? ''
                }

                // Récuperation des données à mettre dans le selecteur de Immatriculation / Marque - Modèle / VHT
                let valueTmp = di.immatriculation
                let labelTmp = di.immatriculation + labelMarqMod
                //let centreTmp = di?.centre?.nom ?? ''
                let centreTmp = di?.centre?.id ?? ''
                let marqueTmp = di?.donneesImmatriculation?.smarque ?? ''
                let modeleTmp = di?.donneesImmatriculation?.smodele ?? ''
                let idTmp = di?.donneesImmatriculation?.id ?? ''
                let idClientDemande = di?.id ?? ''
                let centreLabTmp = di?.centre?.nom ?? ''
                let immatNonTrouveeTmp = ''
                let datePmeTmp = di?.donneesImmatriculation?.sdatePme
                  ? moment(di.donneesImmatriculation.sdatePme).format('DD/MM/YYYY')
                  : ''
                let siteTmp = response.data.site?.find((item) => item?.id === di?.id)?.site

                // Traitement des données des véhicules marque et modèle
                if (di.modele) {
                  getVehicleViaModele(di.modele.id)
                  // getVehiculeSite(di.modele.id)
                  valueTmp = di.modele.marque?.nom + ' - ' + di.modele.nom
                  labelTmp = di.modele.marque?.nom + ' - ' + di.modele.nom
                  centreTmp = di.centre?.id
                  idTmp = di.modele.id
                  idClientDemande = di.id
                  marqueTmp = di.modele.marque?.nom
                  modeleTmp = di.modele.nom
                  centreLabTmp = di.centre?.nom
                  immatNonTrouveeTmp = di.immatriculationNonTrouvee
                  setModeleIdArr((prevMod) => [{[idTmp]: marqueTmp + ' - ' + modeleTmp}])
                } else if (di.vehiculeHorsType) {
                  // Traitement des données des véhicules hors type
                  const newVal = {
                    ...di.vehiculeHorsType,
                    id: di.vehiculeHorsType.marque + ' - ' + di.vehiculeHorsType.nom,
                    marque: {nom: di.vehiculeHorsType.marque},
                    type: {
                      libelle: di.vehiculeHorsType.type,
                      groupe: {libelle: di.vehiculeHorsType.groupe},
                    },
                    isHorsType: true,
                  }
                  setInfoModele([newVal])
                  setImmatriculation(newVal)
                  setDataHorsType((prevData) => [...prevData, newVal])

                  setInfoModeleArr((prevInfo) => [...prevInfo, newVal])
                  setDataImmatArr((prevData) => [...prevData, newVal])

                  valueTmp = di.vehiculeHorsType.marque + ' - ' + di.vehiculeHorsType.nom + ' [VHT]'
                  labelTmp = di.vehiculeHorsType.marque + ' - ' + di.vehiculeHorsType.nom + ' [VHT]'
                  centreTmp = di.centre?.id
                  idTmp = di.vehiculeHorsType.marque + ' - ' + di.vehiculeHorsType.nom
                  idClientDemande = di.id
                  marqueTmp = di.vehiculeHorsType.marque
                  modeleTmp = di.vehiculeHorsType.nom + ' [VHT]'
                  centreLabTmp = di.centre?.nom
                  setModeleIdArr((prevMod) => [
                    // ...prevMod,
                    {[idTmp]: marqueTmp + ' - ' + modeleTmp.replace(' [VHT]', '')},
                  ])
                } else {
                  // Traitement des données des véhicules immatriculation
                  verifyCatdata(di.immatriculation)
                }
                if (di.centre && di.centre.id) {
                  let immatIndex = di.modele ? di.modele.id : di.immatriculation
                  if (di.vehiculeHorsType) {
                    immatIndex = di.vehiculeHorsType.marque + ' - ' + di.vehiculeHorsType.nom
                  }
                  setImmatCentre((prevImmatCentre) => ({
                    ...prevImmatCentre,
                    [immatIndex]: di.centre.id,
                  }))
                }

                // Ajout des immatriculations dans le selecteur de Immatriculation / Marque - Modèle / VHT
                addImmat({
                  value: valueTmp,
                  label: labelTmp,
                  centre: centreTmp,
                  centreLabel: centreLabTmp,
                  id: idTmp,
                  idClientDemande: idClientDemande,
                  marque: marqueTmp,
                  modele: modeleTmp,
                  DeletableOnEdit: true,
                  immatriculationNonTrouvee: immatNonTrouveeTmp,
                  isEdit: true,
                  vin: di?.donneesImmatriculation?.sVin,
                  datePme: datePmeTmp,
                  site: siteTmp,
                })
              })

              // Récupération des pièces
              let piecesTmp: any = []
              response.data.clientDemandePiece?.map((p) => {
                let immat = p?.clientDemandeImmat?.immatriculation ?? ''
                let marque = p?.clientDemandeImmat?.donneesImmatriculation?.smarque ?? ''
                let modele =
                  p?.clientDemandeImmat?.donneesImmatriculation?.stecModele == ''
                    ? p?.clientDemandeImmat?.donneesImmatriculation?.smodele
                    : p?.clientDemandeImmat?.donneesImmatriculation?.stecModele
                if (p?.clientDemandeImmat?.modele) {
                  marque = p?.clientDemandeImmat?.modele?.marque?.nom
                  modele = p?.clientDemandeImmat?.modele?.nom
                  immat = marque + ' - ' + modele
                } else if (p?.clientDemandeImmat?.vehiculeHorsType) {
                  marque = p?.clientDemandeImmat?.vehiculeHorsType?.marque
                  modele = p?.clientDemandeImmat?.vehiculeHorsType?.nom
                  immat = marque + ' - ' + modele + ' [VHT]'
                }
                let newPiece = Object.assign(
                  {...p},
                  {
                    idTypePiece: p?.typePiece?.id,
                    stock: 'chargement',
                    nomTypePiece: p?.typePiece?.nom,
                    immat: immat,
                    typePiece: p?.typePiece,
                    marque: marque,
                    modele: modele,
                    refConst: p?.referenceConstructeur,
                    typePieceHn: p?.typePieceHn,
                    immatriculationNonTrouvee: p?.clientDemandeImmat?.immatriculationNonTrouvee,
                  }
                )
                piecesTmp.push(newPiece)
                let isHorsnom = false
                if (p?.typePieceHn) {
                  isHorsnom = true
                }
                if (p?.clientDemandeImmat?.modele || p?.clientDemandeImmat?.vehiculeHorsType) {
                  let isVht = p?.clientDemandeImmat?.vehiculeHorsType ? ' [VHT]' : ''
                  addPiecesToImmat(marque + ' - ' + modele + isVht, newPiece, null, isHorsnom)
                } else {
                  addPiecesToImmat(p?.clientDemandeImmat?.immatriculation, newPiece, null, isHorsnom)
                }
              })
              setPieces(piecesTmp)
              setLoadStock(true)
              setImmatSelected('Tous')
              toast.update(toastLoader, {
                render: 'Récupération effecutée avec succès',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
            } else {
              handleImmatValide()
            }
          } else {
            // Réponse inattendue (statut != 200 ou absence de data) -> renvoyée vers le .catch
            throw new Error(`Réponse invalide (status: ${response?.status})`)
          }
        })
        .catch((error) => {
          console.error('Erreur lors de la récupération de la demande :', error)
          toast.update(toastLoader, {
            render:
              error?.response?.data?.message ?? 'Erreur lors de la récupération des données',
            type: 'error',
            isLoading: false,
            autoClose: 5000,
          })
          // remettre l'état dans un état cohérent après l'échec
          setLoadStock(false)
          resetFilAriane()
        })
    } else {
      resetFilAriane()
    }
  }, [])

  useEffect(() => {
    //pour verifier les source client est compris dans la source utilisateur connecté
    if (lState?.demandeId !== null) {
      let auto = dataClient?.codeClientAAuto
      let moto = dataClient?.codeClientAMoto
      let indus = dataClient?.codeClientAIndus
      let sourceUser = userConnected?.currentUser?.listeSources
      let sourceData = sourceUser?.[0]
      // Récupérer uniquement les valeurs non vides
      const values = [auto, moto, indus].filter(Boolean)

      //mettre la modification de client en true quand on modifie une demande
      setIsEdit(true)

      // if (values.length > 0 && Array.isArray(sourceData) && sourceData.length > 0) {
      //   const noneExist = values.every((val) => !sourceData.includes(val))
      //
      //   if (noneExist) {
      //     setIsEdit(true)
      //   }
      // }
    }
  }, [lState?.demandeId])

  // Pour obtenir le stock de chaque type pièce durant la modification et pour controller l'arret de la requete
  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    if (loadStock) {
      pieces.forEach(async (demande, index) => {
        let stock = 0
        let ref = demande.refConst && demande.refConst !== '-' ? demande.refConst : ''
        let isHorsType = demande.clientDemandeImmat.vehiculeHorsType

        if (demande?.typePiece?.id) {
          await getTypePieceStockValue(
            demande.typePiece.id,
            '',
            isHorsType !== null ? '' : demande.marque,
            isHorsType !== null ? '' : demande.modele,
            signal
          ).then((res) => (stock = res?.data[0]))
        }

        setPieces((prevTypePiece) => {
          const updatedTypePiece = [...prevTypePiece]
          updatedTypePiece[index] = {...updatedTypePiece[index], stock}
          return updatedTypePiece
        })
      })
    }

    return () => controller.abort()
  }, [loadStock, setLoadStock])

  // gestion des pièces assigner à une immatriculation
  const addPiecesToImmat = (immatriculation: string, newPiece, dataI, isHorNorm) => {
    setImmatPieces((prevData) => {
      // Vérifiez si l'immatriculation existe déjà
      if (prevData[immatriculation]) {
        let verif
        if (isHorNorm && newPiece?.typePiece?.id == null) {
          verif = prevData[immatriculation].some(
            (item) => item?.typePieceHn === newPiece?.typePieceHn
          )
        } else {
          verif = prevData[immatriculation].some(
            (item) => item?.typePiece?.id === newPiece?.typePiece?.id
          )
        }

        if (!verif) {
          // Sinon, ajoutez la nouvelle pièce
          return {
            ...prevData,
            [immatriculation]: [
              ...prevData[immatriculation],
              {...newPiece, immat: immatriculation},
            ],
          }
        } else {
          return prevData
        }
      } else {
        // Si l'immatriculation n'existe pas encore, créez une nouvelle entrée
        return {
          ...prevData,
          [immatriculation]: [{...newPiece, immat: immatriculation}],
        }
      }
    })
  }

  // suppression de pièce affectée à une immatriculation
  const removePieceFromImmat = (pieceId, immatToDel, typePieceHn) => {
    if (!immatPieces[immatToDel]) return immatPieces // Si l'immatriculation n'existe pas, on ne change rien

    // Filtrer les pièces pour enlever celle avec le pieceId donné
    let updatedPieces: any = {}
    if (pieceId) {
      updatedPieces = immatPieces[immatToDel].filter((piece) => piece?.typePiece?.id !== pieceId)
    } else {
      updatedPieces = immatPieces[immatToDel].filter((piece) => piece?.typePieceHn !== typePieceHn)
    }

    // Si plus aucune pièce ne reste, on supprime complètement l'immatriculation
    if (updatedPieces.length === 0) {
      const dataTemp = JSON.parse(JSON.stringify(immatPieces))
      delete dataTemp[immatToDel]
      setImmatPieces(dataTemp)
    } else {
      // Sinon, on met à jour la liste des pièces pour cette immatriculation
      setImmatPieces({
        ...immatPieces,
        [immatToDel]: updatedPieces,
      })
    }
  }

  const formik = useFormik<ModeleClientDemande>({
    initialValues: data,
    validationSchema: clientDemandeSchema,
    onSubmit: (values) => {
      setLoadingOnSave(true)
    },
  })

  useEffect(() => {
    if (demandeId !== undefined && demandeId !== null) {
      if (data.pieces !== undefined) {
        const tmpPieces = [...data.pieces]
        tmpPieces.map((piece) => {
          if (piece.pieceEntre !== undefined && piece.pieceEntre !== null) {
            piece.numeroPieceEntre = piece.pieceEntre.code
            piece.idPieceEntre = piece.pieceEntre.id
          }
        })
        setPieces(tmpPieces)
      }
      if (data.donneesImmatriculation !== undefined) {
        setImmatriculation(data.donneesImmatriculation)
      }
      setImmatriculationValide(true)
    }
  }, [demandeId])

  const getCentresData = () => {
    let centreIds: string | undefined = ''
    if (userConnected) {
      let userCentre = userConnected?.currentUser?.listeCentres?.[0]
      if (userCentre?.length > 0) {
        centreIds = userCentre?.map((centre) => centre?.id)?.join(',')
      }
    }

    getCentres(currentPage, searchPage, centreIds)
      .then((centresRequest) => {
        if (centresRequest?.data !== undefined) {
          const transformedData = centresRequest.data.map((item) => ({
            value: item.id,
            label: item.nom,
          }))
          setCentres([...transformedData])
          setCentre(transformedData[0])
        }
      })
      .catch((e) => {})
  }

  useEffect(() => {
    if (dataImmatArr.length === 1) {
      setDataImmatSelected(dataImmatArr[0])
    }
  }, [dataImmatArr])

  useEffect(() => {
    immatsArray.length == 0 ? setVehicleInfo(true) : setVehicleInfo(false)
    getCentresData()
    // Sélectionne de la première immat
    if (immatsArray.length == 1) {
      setImmatSelected(immatsArray[0]?.value)
      setIsTous(false)
      setIsDeletable(false)
    } else {
      //setIsTous(true)
      setIsDeletable(true)
    }
    //setImmatAssignCentre(immatsArray[0]?.id)

    // Affichage de notification toast si le centre de la vehicule n'est pas dans les centres de l'utilisateur connecté
    const centres = userConnected?.currentUser?.listeCentres?.[0] || []
    immatsArray.forEach((immat, key) => {
      if (centres.length > 0) {
        if (
          !centres.some((centre) => centre?.id === immat?.centre || centre?.id === immat?.centreId)
        ) {
          toast.warning(
            `${immat.value} n’est pas dans votre centre. Transférez-le pour ajouter des pièces.`,
            {autoClose: 5000}
          )
          setTimeout(() => {
            refCentres?.current?.[key]?.click()
          }, 1000)
        } else {
          if (immatAssignCentre === immat.id) {
            const checkCentreImmat = centres.some(
              (centre) => centre?.id === immat?.centre || centre?.id === immat?.centreId
            )
            if (checkCentreImmat) {
              setImmatSelected(immat.value)
              setIsTous(false)
              //setIsDeletable(false)
            }
          }
        }
      }
    })
  }, [immatsArray])

  useEffect(() => {
    if (demandeId !== undefined && demandeId !== null) {
      const intervalId = setInterval(() => {
        const currentDate = moment()
        const dateDemande = moment(data?.dateCreation)

        var duration = moment.duration(currentDate.diff(dateDemande))

        let totalSeconds: number = duration.asSeconds()
        let hours = Math.floor(totalSeconds / 3600)
        totalSeconds %= 3600
        let minutes = Math.floor(totalSeconds / 60)
        let seconds = totalSeconds % 60

        const hoursStr = String(hours).padStart(2, '0')
        const minutesStr = String(minutes).padStart(2, '0')
        const secondsStr = String(seconds.toFixed(0)).padStart(2, '0')

        setTempsEcoule(`${hoursStr}:${minutesStr}:${secondsStr}`)
      }, 1000)

      return () => clearInterval(intervalId)
    }
  }, [demandeId])

  // verifier les données immatriculation par l'immatriculation
  useEffect(() => {
    verifyCatdata(immat)
  }, [immat])

  //Vérifie si tout les immat ont au moins une piece
  useEffect(() => {
    Object.keys(immatPieces).length != immatsArray.length
      ? setShowNoPieceOnImmat(true)
      : setShowNoPieceOnImmat(false)
  }, [immatPieces, immatsArray, pieces])

  const CheckAllImmat = (immat) => {
    const id = toast.loading('Recherche des véhicules en cours...')
    toastId.current = id

    let toastClosed = false

    Promise.all(
      immat.map(async (im) => {
        const result = await verifyCatdata(im)

        // Si succès et toast encore actif, on le met à jour
        if (result.status === 'success' && !toastClosed && toastId.current) {
          toast.update(toastId.current, {
            render: 'Véhicule identifié',
            type: 'success',
            isLoading: false,
            // autoClose: 3000,
          })
          toastClosed = true
          toastId.current = undefined
        }

        return result.status
      })
    )
      .then((results) => {
        const hasSuccess = results.includes('success')
        const allNotFound = results.every((res) => res === 'not_found')

        // Si aucun succès et toast encore actif
        if (!hasSuccess && !toastClosed && toastId.current) {
          toast.update(toastId.current, {
            render: allNotFound
              ? 'Aucun véhicule identifié'
              : 'Erreur lors de la vérification des véhicules',
            type: 'error',
            isLoading: false,
            autoClose: 3000,
          })
          toastClosed = true
          toastId.current = undefined
        }
      })
      .catch(() => {
        // Gestion d'erreur globale
        if (!toastClosed && toastId.current) {
          toast.update(toastId.current, {
            render: 'Erreur inattendue pendant la vérification',
            type: 'error',
            isLoading: false,
            autoClose: 3000,
          })
          toastClosed = true
          toastId.current = undefined
        }
      })
  }

  // Récupération des données si en cas de reload de la page
  useEffect(() => {
    // Récupération des immat
    if (lState?.immat && lState?.immat.length !== 0) {
      // Afficher le toast loading et stocker son ID
      CheckAllImmat(lState?.immat)
    }
    // Récupération des données dataVehicle de lState pour le rechargement
    if (lState?.dataVehicle && Object.keys(lState?.dataVehicle).length !== 0) {
      setLoading(false)

      const updatedData = {...immatriculation}
      const immatToAdd: {
        value: string
        label: string
        centreLabel: string
        centreId: string
        marque: string
        modele: string
        id: number
        isHorsType: boolean
        immatriculationNonTrouvee: string
        vin?: string | null
        datePme?: string | null
        site?: number | string | null | undefined
      }[] = []
      const modeleIdToAdd: {[key: number]: string}[] = []
      const existingIds = new Set(dataImmatArr.map((item) => item.id))
      const newDataImmatArr = [...dataImmatArr]
      const newDataHorsType = [...dataHorsType]
      const allDataVehicles: any[] = []

      for (const key of Object.keys(lState?.dataVehicle)) {
        const dataVehicle = lState?.dataVehicle[key]
        if (!dataVehicle) continue

        const id = dataVehicle?.id
        const marque = dataVehicle?.marque?.nom
        const modele = dataVehicle?.nom
        const site = dataVehicle?.site

        if (!marque || !modele || !id) continue

        updatedData[id] = dataVehicle

        if (!existingIds.has(id)) {
          newDataImmatArr.push(dataVehicle)
          existingIds.add(id)
        }

        modeleIdToAdd.push({[id]: `${marque} - ${modele}`})

        if (dataVehicle?.isHorsType) {
          newDataHorsType.push(dataVehicle)
        }

        immatToAdd.push({
          value: `${marque} - ${modele}${dataVehicle?.isHorsType ? ' [VHT]' : ''}`,
          label: `${marque} - ${modele}${dataVehicle?.isHorsType ? ' [VHT]' : ''}`,
          centreLabel: '',
          centreId: '',
          marque,
          modele,
          id,
          isHorsType: dataVehicle?.isHorsType,
          immatriculationNonTrouvee: dataVehicle?.immatriculationNonTrouvee,
          datePme: '',
          site: site ?? null,
        })

        allDataVehicles.push(dataVehicle)
      }

      if (allDataVehicles.length > 0) {
        setImmatriculation(updatedData)
        setDataImmatArr(newDataImmatArr)
        setDataImmatSelected(allDataVehicles[0])
        setDataHorsType(newDataHorsType)
        setInfoModeleArr(allDataVehicles)
        setInfoModele(allDataVehicles)
        setModeleIdArr((prev) => [
          // ...prev,
          ...modeleIdToAdd.filter(
            (newItem) => !prev.some((item) => Object.keys(item)[0] === Object.keys(newItem)[0])
          ),
        ])
        setImmatriculationValide(true)
        formik.setFieldValue('immatriculation', allDataVehicles[0]?.nom)
        setSpinner(false)

        for (const immat of immatToAdd) {
          addImmat(immat)
        }
      }
    }

    // Loader tout les noms dans TypePiece une seule fois pour faciliter le traitement de l'autocompletion
    getAllPieceTypePiece()
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data !== undefined) {
            setSuggestion(res?.data)
          }
        }
      })
      .catch(() => console.error('Erreur'))
  }, [])

  const handleInitialEdit = () => {
    setIdTypePieceEdit(undefined)
    setTypePieceEditHn('')
  }

  // Suppression des toast si ToastId est undefined
  useEffect(() => {
    if (toastId.current == undefined) {
      toast.dismiss(toastId.current)
    }
  }, [toastId.current])

  // vérification des données immatriculations par l'immatriculation
  const verifyCatdata = async (immat) => {
    const immatriculation = immat ?? formik.values?.immatriculation
    if (immatriculation) {
      setLoading(false)

      try {
        const immatriculationRequest = await getCatdata(immatriculation)

        if (immatriculationRequest?.status === 200 && immatriculationRequest?.data) {
          if (
            immatriculationRequest.data.sMessageErreur === 'No data for this vehicle' ||
            immatriculationRequest.data.sMessageErreur === null
          ) {
            setImmatriculationValide(true)
            return {data: immatriculationRequest?.data, status: 'not_found'}
          } else {
            getSiteVehiculeImmat(immatriculationRequest.data?.id).then((response) => {
              if (response?.status === 200 && response?.data !== undefined) {
                const updatedData = {
                  ...immatriculation,
                  ...immatriculationRequest.data,
                  site: response?.data?.site?.toString(),
                }
                setImmatriculation(updatedData)
                getGenreByCode({...immatriculationRequest, site: response?.data?.site?.toString()})
                setSiteSelected(response?.data?.site?.toString() ?? null)
              }
            })
            setInfoModele([])
            const exist = dataImmatArr.some((item) => item.id === immatriculationRequest?.data?.id)
            if (!exist) {
              setDataImmatArr((prevData) => [...prevData, immatriculationRequest.data])
              setDataImmatSelected(immatriculationRequest.data)
            }

            setImmatriculationValide(true)
            await formik.setFieldValue(
              'immatriculation',
              immatriculationRequest.data.sImmatriculationSiv
            )
            setSpinner(false)
            return {data: immatriculationRequest?.data, status: 'success'}
          }
        } else {
          setImmatriculationValide(false)
          return {data: null, status: 'error'}
        }
      } catch (ex: any) {
        if (ex?.response?.status === 500) {
          setImmatriculationValide(true)
          setSpinner(false)
        }
        return {data: null, status: 'error'}
      } finally {
        setLoading(false)
      }
    }

    return {data: null, status: 'skipped'}
  }

  // Vérification des données immatriculations par marque et modèle
  const getVehicleViaModele = async (idModele) => {
    //const immatriculation = immat ?? formik.values?.immatriculation
    setLoading(false)
    const toastId = toast.loading('Identification du véhicule...')
    try {
      setDisableInput(true)
      const modeleResponse = await getOneVehicleModele(idModele)
      if (modeleResponse?.status === 200 && modeleResponse?.data) {
        setInfoModele([{...modeleResponse.data, isHorsType: false}])
        setImmatriculation(modeleResponse.data)

        const isIn = infoModeleArr.some((item) => item.id === modeleResponse.data.modele.id)
        if (!isIn) {
          setInfoModeleArr((prevInfo) => [...prevInfo, modeleResponse.data])
          setDataImmatArr((prevData) => [...prevData, modeleResponse.data])
        }

        setImmatriculationValide(true)
        setSpinner(false)
        toast.update(toastId, {
          render: 'Véhicule identifié',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      } else {
        setImmatriculationValide(false)
        toast.update(toastId, {
          render: 'Véhicule non identifié',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }
      setDisableInput(false)
    } catch (ex: any) {
      if (ex.response?.status === 500) {
        setImmatriculationValide(true)
        setSpinner(false)
      }
    } finally {
      setLoading(false)
    }
  }

  // ajout immat dans le state location(stockage des immats en cas de rechargment)
  const ajouterImmat = (nouvelleImmat: string) => {
    const prevState = lState || {immat: []}

    if (!prevState.immat || prevState?.immat?.includes(nouvelleImmat)) {
      return
    }

    navigate('.', {
      replace: true,
      state: {
        ...prevState,
        immat: [nouvelleImmat],
      },
    })
  }

  const supprimerImmat = (immatToDelete: string) => {
    const prevState = lState || {immat: []}
    if (!prevState.immat || !prevState?.immat?.includes(immatToDelete)) {
      return
    }
    navigate('.', {
      replace: true,
      state: {
        ...prevState,
        immat: prevState.immat.filter((immat) => immat !== immatToDelete),
      },
    })
  }

  // récupération du genre pour avoir le centre correspondant
  const getGenreByCode = (immatriculationRequest) => {
    const immat = immatriculationRequest?.data?.sImmatriculationSiv
    const modeleV = immatriculationRequest?.data?.smodele
    const marqueV = immatriculationRequest?.data?.smarque
    const genreCode = immatriculationRequest?.data?.sgenre

    if (!immat) return

    //marque et modèle ajouter au label immatriculation
    let labelMarqMod = ''
    if (immatriculationRequest?.data?.smarque) {
      labelMarqMod = ' - ' + immatriculationRequest?.data?.smarque ?? ''
    }
    if (immatriculationRequest?.data?.smodele) {
      labelMarqMod += ' - ' + immatriculationRequest?.data?.smodele ?? ''
    }

    const exists = immatsArrayRef.current.some((item) => item.value === immat)
    if (exists) return
    postGenreByCode(genreCode).then((genre) => {
      if (genre?.status === 200 && genre?.data !== undefined) {
        if (immat) {
          const exists = immatsArray.some((item) => item.value === immat)
          if (!exists) {
            addImmat({
              value: immat,
              label: immat + labelMarqMod,
              centreLabel: genre.data.centreDefaut?.nom ?? '',
              centreId: genre.data.centreDefaut?.id ?? '',
              marque: marqueV ?? '',
              modele: modeleV ?? '',
              id: immatriculationRequest?.data?.id,
              vin: immatriculationRequest?.data?.sVin,
              datePme: immatriculationRequest?.data?.sdatePme
                ? moment(immatriculationRequest.data.sdatePme).format('DD/MM/YYYY')
                : '',
              site: immatriculationRequest?.site ?? null,
            })
            // setter les données de centre et immat à envoyer
            if (allowAddCentre) {
              setImmatCentre((prevImmatCentre) => ({
                ...prevImmatCentre,
                [immat]: genre.data.centreDefaut?.id,
              }))
              allowAddCentre = false
            }
            ajouterImmat(immat)
            setCentreSelected({
              label: genre.data.centreDefaut?.nom ?? '',
              value: genre.data.centreDefaut?.id,
            })
          }
        }
      }
    })
  }

  const deletePieceline = (
    pieceId: number | undefined,
    immatToDel: string | undefined,
    typePieceHn: string | null | undefined
  ) => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        setPieces((prevPieces) => {
          return prevPieces.filter((piece) => {
            if (immatSelected === 'Tous') {
              // Supprimer normalement en fonction du pieceId et de son immat
              if (pieceId) return !(piece.typePiece?.id === pieceId && piece.immat === immatToDel)
              else return !(piece.typePieceHn === typePieceHn && piece.immat === immatToDel)
            }
            // Supprimer seulement si la pièce correspond à l'immatriculation sélectionnée
            if (pieceId) return !(piece.typePiece?.id === pieceId && piece.immat === immatSelected)
            else return !(piece.typePieceHn === typePieceHn && piece.immat === immatSelected)
          })
        })

        removePieceFromImmat(pieceId, immatToDel, typePieceHn)
      }
    })
  }

  // affichage des données de pièces liées aux immatriculations
  const renderPiecesTable = () => {
    return <>{renderFormRowPieces()}</>
  }

  // affichage des immats recherchées avec leur centre
  const renderImmatTable = () => {
    return <>{renderFormRowImmat()}</>
  }

  const updateFieldValue = (immatConcernee, field, value, idTypePiece, typePieceHn) => {
    const isHN = !!typePieceHn
    const matchFn = (piece) =>
      piece?.immat === immatConcernee &&
      (isHN ? piece?.typePieceHn === typePieceHn : piece?.typePiece?.id === idTypePiece)

    setPieces((prevPieces) =>
      prevPieces.map((piece) => (matchFn(piece) ? {...piece, [field]: value} : piece))
    )

    setImmatPieces((prevState) => {
      const updatedImmatPieces = {...prevState}
      const updatedPieceArr = [...(updatedImmatPieces[immatConcernee] || [])]
      const pieceIndex = updatedPieceArr.findIndex((p) =>
        isHN ? p?.typePieceHn === typePieceHn : p?.typePiece?.id === idTypePiece
      )

      if (pieceIndex !== -1) {
        updatedPieceArr[pieceIndex] = {
          ...updatedPieceArr[pieceIndex],
          [field]: value,
        }
      }

      updatedImmatPieces[immatConcernee] = updatedPieceArr
      return updatedImmatPieces
    })
  }

  // Gestion de l'input quantité(mettre 1 si c'est vide ou négatif ou incorrect)
  const handleBlur = (immatConcernee, idTypePiece) => {
    setPieces((prevPieces) => {
      const updatedPieces = [...prevPieces]
      const piece = updatedPieces.find(
        (p) => p.immat === immatConcernee && p?.typePiece?.id === idTypePiece
      )

      if (
        piece &&
        (piece?.quantite === '' || piece?.quantite === undefined || piece?.quantite <= 0)
      ) {
        const updatedPiece = {...piece, quantite: 1}
        const pieceIndex = updatedPieces.findIndex(
          (p) => p.immat === immatConcernee && p?.typePiece?.id === idTypePiece
        )
        updatedPieces[pieceIndex] = updatedPiece
      }

      return updatedPieces
    })
  }

  // gestion de la sélection de centre
  const handleCentreChange = (selectedOptions) => {
    formik.setFieldValue('u_centre', selectedOptions.value)
    setCentreSelected(selectedOptions)
    setCentre(selectedOptions?.value)
    setCentreLabel(selectedOptions?.label)
  }

  // gestion du transfert de centre
  const handleTransfert = (newObj) => {
    // setter le centre transférer à l'immatriculation
    setImmatCentre((prevImmatCentre) => ({
      // ...prevImmatCentre,
      [vehicleAssignCentre]: newObj.value,
    }))

    editCentreImmat(immatAssignCentre, {id: centre, label: centreLabel})
  }

  const handleTransfertHn = (pieceCentreAssign) => {
    let demandeId = lState?.demandeId
    if (immatPieces[pieceCentreAssign.immat]) {
      const immatData = immatPieces[pieceCentreAssign.immat]
      for (const index in immatData) {
        const currentPiece = immatData[index]
        if (!demandeId) {
          if (currentPiece?.typePiece.nom === pieceCentreAssign?.typePiece.nom) {
            //mise à jour de immatPieces
            immatData[index] = {
              ...currentPiece,
              centre: pieceCentreAssign?.centre,
            }
            // Mise à jour dans piece
            for (const key in pieces) {
              if (
                pieces[key]?.typePiece?.nom === pieceCentreAssign?.typePiece?.nom &&
                pieces[key]?.immat === pieceCentreAssign?.immat
              ) {
                pieces[key] = {
                  ...pieces[key],
                  centre: pieceCentreAssign?.centre,
                }
              }
            }
          }
        } else {
          if (pieceCentreAssign?.idTypePiece) {
            if (currentPiece?.nomTypePiece === pieceCentreAssign?.nomTypePiece) {
              //mise à jour de immatPieces
              immatData[index] = {
                ...currentPiece,
                centre: pieceCentreAssign?.centre,
              }
              // Mise à jour dans piece
              for (const key in pieces) {
                if (
                  pieces[key]?.nomTypePiece === pieceCentreAssign?.nomTypePiece &&
                  pieces[key]?.immat === pieceCentreAssign?.immat
                ) {
                  pieces[key] = {
                    ...pieces[key],
                    centre: pieceCentreAssign?.centre,
                  }
                }
              }
            }
          } else {
            if (currentPiece?.typePieceHn === pieceCentreAssign?.typePieceHn) {
              immatData[index] = {
                ...currentPiece,
                centre: pieceCentreAssign?.centre,
              }
              for (const key in pieces) {
                if (
                  pieces[key]?.typePieceHn === pieceCentreAssign?.typePieceHn &&
                  pieces[key]?.immat === pieceCentreAssign?.immat
                ) {
                  pieces[key] = {
                    ...pieces[key],
                    centre: pieceCentreAssign?.centre,
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  // affichage des infos de véhicule par immatriculation
  const handleInfoVehicle = (immat, isViaImmat: boolean) => {
    setShowDetailVehicule(true)
    if (isViaImmat) {
      verifyCatdata(immat)
      setInfoModele([])
    } else {
      const marq = immat.marque
      let mod = immat.modele
      mod = mod.includes('[VHT]') ? mod.replace(' [VHT]', '') : mod
      let infoFiltered = [...infoModeleArr]
      infoFiltered = infoFiltered.filter((i) => i.marque.nom == marq && i.nom == mod)
      setInfoModele(infoFiltered)
      setImmatriculation(infoFiltered[0])
    }
    formik.setFieldValue('immatriculation', immat)
  }

  // soumission du formulaire de confirmation de la création ou de modification d'une demande
  const SubmitDemande = (isDupl: boolean = false, equipeParam?: any) => {
    if (!isDupl) setLoadingOnSave(true)
    else setLoadingOnSaveAndDupl(true)
    const equipe = equipeParam || selectedEquipe
    const contactValue = isConfirmEdit ? defaultValueContact : null

    const adresseFactToSend = {
      ...updatedAdresseFactInfo,
    }

    const adresseLivToSend = {
      ...updatedAdresseLivInfo,
    }

    if (adresseFactToSend.id === adresseLivToSend.id) {
      if (adresseFactToSend.edited) {
        adresseFactToSend.id = ''
      }

      if (adresseLivToSend.edited) {
        adresseLivToSend.id = ''
      }
    }

    let action = demandeId ? editDemandes : postDemandes
    action(
      idClient,
      immatCentre,
      immatPieces,
      demandeId ?? null,
      modeleIdArr,
      dataHorsType,
      // lState?.defaultValueContact?.value,
      lState?.defaultValueContact,
      lState?.radioValue,
      demandeSourceValue,
      isConfirmEdit ? contentCommunication : lState?.contentCommunication,
      contactValue,
      isAdresseUpdated,
      adresseFactToSend,
      adresseLivToSend,
      equipe,
      retraitDepot,
      images
    )
      .then((clientDemandeRequest) => {
        if (clientDemandeRequest?.status === 200) {
          if (clientDemandeRequest?.data !== undefined) {
            if (demandeId) {
              toast.success('Demande modifiée avec succès')
            } else {
              toast.success('Demande créée avec succès')
            }
            // Pour la création et traitement direct
            if (
              shouldDisplayFonctionnalite(currentUser, 'CREER ET TRAITER DEMANDE') &&
              !lState?.demandeId &&
              !isDupl
            ) {
              navigate(`/demandes/${idClient}/traitement/${clientDemandeRequest?.data?.id}`)
              return
            }

            const linkToDemandeTraitement: boolean =
              fromTraitement == undefined ? false : fromTraitement
            navigate(
              linkToDemandeTraitement
                ? demandeTraitement
                : redirectToClientDemande
                ? clientDemandePath
                : isFromClient
                ? clientDemandePath
                : DemandeListPath,
              {
                state: {
                  ...(demandeId ? {showEditToast: true} : {showSubmitToast: true}),
                  filters,
                  isFromClient: lState?.isFromClient,
                  redirectToClientDemande: lState?.redirectToClientDemande,
                  clientToDuplicate: {
                    clientId: isDupl ? idClient : null,
                    defaultValueContact: isDupl ? lState?.defaultValueContact : '',
                    contentCommunication: isDupl
                      ? lState?.contentCommunication ?? contentCommunication
                      : '',
                    radioValue: isDupl ? lState?.radioValue : '',
                    contactedBy: isDupl ? contactedByDm : null,
                    choicedDemandeSource: isDupl ? demandeSourceValue : '',
                    isDuplication: true,
                    searchTerm: demandeId
                      ? dataClient
                        ? dataClient?.professionnel
                          ? dataClient?.nomSociete
                          : dataClient?.nom + ' ' + dataClient?.prenom
                        : ''
                      : searchTerm,
                  },
                },
              }
            )
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const handleCenter = (e, obj) => {
    e.stopPropagation() // empêcher l'affichage de l'information du véhicule via td au clique du bouton transfert de centre
    /* pour setSelectedOption affectation centre:
    On récupère value avec la priorité à obj.centre, sinon obj.centreId.
    Si value existe, on set selectedOption avec value et label.
    Sinon, on passe une chaîne vide "". */
    const value = obj.centre || obj.centreId
    const label = obj.centreLabel
    setSelectedOption(value ? {value, label} : '')

    setCentreSelected({value: obj.centreId, label: obj.centreLabel ?? ''})
    setImmatAssignCentre(obj.id)
    setVehicleAssignCentre(obj.value.includes('-') ? obj.id : obj.value)
  }

  const handleCenterHn = (piece) => {
    if (piece?.centre && piece.centre.id !== '') {
      setSelectedOptionHn({
        value: piece?.centre?.id,
        label: piece?.centre?.nom,
      })
    } else {
      setSelectedOptionHn('')
    }
    setPieceCentreAssign(piece)
  }

  const getAllClientAdresses = () => {
    getClientAdresses(idClient).then((res) => {
      if (res.status === 200) {
        setClientAdresses(res.data)
      }
    })
  }

  // Gestion des copies en ligne
  const handleCopie = (texte, e) => {
    e.stopPropagation()
    copyText(texte, setCheckCopy, 500)
  }

  // composant affichage des immatriculations recherchées
  const renderFormRowImmat = () => {
    return immatsArray.map((object, index) => {
      const immatToShow = object?.immatriculationNonTrouvee
        ? object?.immatriculationNonTrouvee + ' [NT]'
        : object.value.includes('-')
        ? ''
        : object.value
      return (
        <tr
          key={index}
          className={`cursor-pointer ${
            (immatriculation?.marque?.nom &&
              immatriculation?.nom &&
              object.value?.split(' - ')[0] === immatriculation.marque?.nom &&
              object.value?.split(' - ')?.slice(1)?.join(' - ') === immatriculation.nom) ||
            object.value === immatriculation?.id + ' [VHT]'
              ? 'bg-gray-200'
              : immatriculation?.sImmatriculationSiv === object.value
              ? 'bg-gray-200'
              : ''
          }`}
          onClick={() =>
            handleInfoVehicle(
              object?.value.includes('-')
                ? {marque: object.marque, modele: object.modele}
                : object.value,
              !object.value.includes('-')
            )
          }
        >
          <td>
            <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
              {immatToShow}
              {(immatToShow !== '' || object?.value == immatriculation?.sImmatriculationSiv) &&
                (checkCopy !== object.value || checkCopy !== object?.immatriculationNonTrouvee ? (
                  <i
                    className='ki-duotone ki-copy cursor-pointer fs-2 ms-2'
                    onClick={(e) => handleCopie(immatToShow, e)}
                  ></i>
                ) : (
                  <i className='ki-duotone ki-copy-success text-primary fs-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                ))}
            </p>
          </td>
          <td>{object?.centreLabel}</td>
          <td>{object?.marque}</td>
          <td>
            {object?.modele} {object?.isHorsType ? '[VHT]' : ''}
          </td>
          <td>{object?.datePme}</td>
          <td>
            {object?.vin}
            {object?.vin &&
              (checkCopy !== object.vin ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2 ms-2'
                  onClick={(e) => handleCopie(object.vin, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success text-primary fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </td>
          <td onClick={(e) => e.stopPropagation()}>
            <div className='d-flex gap-3 justify-content-center'>
              <span className='btn btn-icon btn-bg-light btn-active-color-info btn-sm'>
                <i
                  className='ki-duotone ki-information-2 fs-2x btn-active-color-info'
                  onClick={() =>
                    handleInfoVehicle(
                      object?.value.includes('-')
                        ? {marque: object.marque, modele: object.modele}
                        : object.value,
                      !object.value.includes('-')
                    )
                  }
                  style={{cursor: 'pointer'}}
                  data-tooltip-id='tooltip'
                  data-tooltip-content='Infos du véhicule'
                  data-tooltip-place='left'
                >
                  <span className='path1'></span>
                  <span className='path2'></span>
                  <span className='path3'></span>
                </i>
              </span>
              <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <i
                  className='bi bi-arrows-angle-contract fs-3'
                  style={{cursor: 'pointer'}}
                  onClick={(e) => handleCenter(e, object)}
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_transfert'
                  data-bs-dismiss='true'
                  data-tooltip-id='tooltip'
                  data-tooltip-content='Transférer'
                  data-tooltip-place='bottom'
                  ref={(el) => (refCentres.current[index] = el)}
                ></i>
              </span>
              {(clientDemande?.clientDemandeEtape?.code === 'NOUVE' || clientDemande?.clientDemandeEtape?.code === 'ASSIG')
                && isDeletable && (
                <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <i
                    className='ki-duotone ki-trash fs-2x'
                    onClick={
                      isDeletable
                        ? (e) =>
                            deleteImmat(
                              e,
                              object.DeletableOnEdit,
                              object.value,
                              object.id,
                              object.idClientDemande
                            )
                        : undefined
                    }
                    style={{
                      color: isDeletable && hover === index ? '#f1416c' : '',
                      transition: isDeletable ? 'color 0.3s ease' : undefined,
                      cursor: isDeletable ? 'pointer' : 'not-allowed',
                    }}
                    onMouseEnter={isDeletable ? () => setHover(index) : undefined}
                    onMouseLeave={isDeletable ? () => setHover(null) : undefined}
                    data-tooltip-id={isDeletable ? 'tooltip' : undefined}
                    data-tooltip-content={isDeletable ? 'Supprimer le véhicule' : undefined}
                    data-tooltip-place={isDeletable ? 'right' : undefined}
                  >
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                    <span className='path5'></span>
                  </i>
                </span>
              )}
              {(clientDemande?.clientDemandeEtape?.code === 'NOUVE' || clientDemande?.clientDemandeEtape?.code === 'ASSIG' || location.pathname.includes('demandes/create')) && (
                <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <i
                  className='ki-duotone ki-pencil fs-2x'
                  data-tooltip-id='tooltip'
                  data-tooltip-content='Modifier le véhicule'
                  data-tooltip-place='right'
                  data-bs-target='#exampleModalSearchV'
                  data-bs-toggle='modal'
                >
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              </span>
              )}
            </div>
          </td>
        </tr>
      )
    })
  }

  const editPiece = (piece) => {
    if (!piece) {
      return
    }
    if (piece?.idTypePiece) {
      setIdTypePieceEdit(piece?.idTypePiece)
    } else if (piece?.typePieceHn) {
      setTypePieceEditHn(piece?.typePieceHn)
    }
    setIsTous(false)
    setSearchValue(piece?.nomTypePiece)
    setImmatPieceEdit(piece?.immat)
    setImmatSelected(piece?.immat)
    searchPieceTypePiece(piece?.idTypePiece ? piece?.nomTypePiece : piece?.typePieceHn)
  }

  // composant affichage des pièces assignées aux immatriculations
  const renderFormRowPieces = () => {
    return pieces
      .filter(
        (piece) =>
          immatSelected === 'Tous' ||
          piece.immat === immatSelected ||
          piece.immat === immatSelected.replace(' [VHT]', '')
      )
      .map((piece, index) => {
        let im = piece?.immat
        let mq = piece?.marque
        let md = piece?.modele
        return (
          <tr
            key={index}
            style={
              piece.idTypePiece && piece.idTypePiece === idTypePieceEdit
                ? {background: '#dcdcdc9e'}
                : piece.typePieceHn && piece.typePieceHn === typePieceEditHn
                ? {background: '#dcdcdc9e'}
                : {}
            }
          >
            <td>
              <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                {piece.idTypePiece !== undefined && piece.idTypePiece !== null
                  ? [
                      piece.typePiece !== undefined &&
                      piece.typePiece !== null &&
                      piece.typePiece?.id !== undefined
                        ? formatTypePiecePourDemande(piece.typePiece)
                        : piece.referenceManuelle,
                    ]
                  : piece?.typePieceHn
                  ? '[999999] - ' + piece.typePieceHn
                  : piece.nomTypePiece}
              </p>
            </td>
            <td>
              <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                {piece?.immatriculationNonTrouvee
                  ? piece?.immatriculationNonTrouvee + ' [NT]'
                  : im?.includes('-')
                  ? ''
                  : im}
              </p>
            </td>
            <td>
              <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                {mq} / {md} {im?.includes('[VHT]') ? ' [VHT]' : ''}
              </p>
            </td>
            <td>
              <textarea
                className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0 fs-7'}
                name={'commentaire' + index}
                placeholder={'Commentaire'}
                style={{maxHeight: '170px'}}
                value={piece.commentaire}
                // disabled={isTous}
                onChange={(e) => {
                  updateFieldValue(
                    piece.immat,
                    'commentaire',
                    e.target.value,
                    piece.idTypePiece,
                    piece?.typePieceHn
                  )
                }}
              ></textarea>
            </td>
            <td>
              <input
                type={'text'}
                className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0 fs-7'}
                name={'refOE' + index}
                placeholder={'Référence OE'}
                value={piece.refConst ?? ''}
                onChange={(e) => {
                  e.target.value = e.target.value.replaceAll(' ', '')
                  updateFieldValue(
                    piece.immat,
                    'refConst',
                    e.target.value,
                    piece.idTypePiece,
                    piece?.typePieceHn
                  )
                }}
              />
            </td>
            <td style={{width: '120px'}}>
              <input
                type={'number'}
                className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                name={'quantite' + index}
                placeholder={'Quantité'}
                value={piece.quantite}
                onChange={(e) => {
                  // empêche l'insertion des valeurs décimal
                  const value = e.target.value
                  if (/^\d+$/.test(value) || value === '') {
                    updateFieldValue(
                      piece.immat,
                      'quantite',
                      value,
                      piece.idTypePiece,
                      piece?.typePieceHn
                    )
                  }
                }}
                min={1}
                onBlur={() => handleBlur(piece.immat, piece.idTypePiece)}
                disabled={stockLoading}
              />
            </td>
            <td>
              <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                {piece.stock === 'chargement' ? (
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                ) : (
                  piece.stock
                )}
              </p>
            </td>
            <td>
              <div className='d-flex justify-content-end flex-shrink-0 gap-2'>
                {((piece.idTypePiece && idTypePieceEdit !== piece.idTypePiece) ||
                  (piece.typePieceHn && typePieceEditHn !== piece.typePieceHn)) && (
                  <p className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                    <i
                      className='ki-duotone ki-pencil fs-2x'
                      style={{cursor: 'pointer'}}
                      data-bs-dismiss='true'
                      data-tooltip-id='tooltip'
                      data-tooltip-content='Modifier'
                      data-tooltip-place='left'
                      onClick={() => editPiece(piece)}
                    >
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </p>
                )}
                {/*<p className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>*/}
                {/*  <i*/}
                {/*    className='bi bi-arrows-angle-contract fs-2'*/}
                {/*    style={{cursor: 'pointer'}}*/}
                {/*    data-bs-toggle='modal'*/}
                {/*    data-bs-target='#kt_modal_transfert_hn'*/}
                {/*    data-bs-dismiss='true'*/}
                {/*    data-tooltip-id='tooltip'*/}
                {/*    data-tooltip-content='Transférer la pièce à un centre'*/}
                {/*    data-tooltip-place='bottom'*/}
                {/*    onClick={() => handleCenterHn(piece)}*/}
                {/*  ></i>*/}
                {/*</p>*/}

                {piece.id !== undefined &&
                  suggestionsProduits[piece.id] !== undefined &&
                  suggestionsProduits[piece.id] !== null && (
                    <a
                      href={`https://shop.koena.fr/piece?sku=${suggestionsProduits[piece.id]}`}
                      target={'_blank'}
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <i className='bi bi-basket fs-5'></i>
                    </a>
                  )}
                {(demandeId === null ||
                  !data?.clientDemandeEtape ||
                  data?.clientDemandeEtape?.id === 1) && (
                  <p
                    onClick={() => {
                      deletePieceline(piece?.typePiece?.id, piece?.immat, piece?.typePieceHn)
                    }}
                    className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                  >
                    <i
                      className='ki-duotone ki-trash fs-2x'
                      data-tooltip-id='tooltip'
                      data-tooltip-content='Supprimer la pièce'
                      data-tooltip-place='right'
                    >
                      <span className='path1'></span>
                      <span className='path2'></span>
                      <span className='path3'></span>
                      <span className='path4'></span>
                      <span className='path5'></span>
                    </i>
                  </p>
                )}
              </div>
            </td>
          </tr>
        )
      })
  }

  function searchTypePiece(value) {
    timeoutRef.current = setTimeout(() => {
      if (value !== '') {
        setPieceSpinner(true)
        setDisableImmatSelect(true)
        getSearchPieceTypePiece(value, false, siteSelected)
          .then((res) => {
            if (res?.status === 200) {
              if (res?.data !== undefined) {
                setResultShowPiece(true)
                const data = res.data
                const newData = data.filter(
                  (d) => d.nom !== null && d.nom !== 'null' && d.nom !== 'NULL'
                ) //suppression des données avec 'nom' = null
                setResultShowPiece(true)
                setPieceTypePiece(newData)
                setPieceSpinner(false)
                setDisableImmatSelect(false)
              }
            }
          })
          .catch(() => {
            console.error('Erreur')
          })
      }
    }, 800)
  }

  // gestion recherche de pièce par type pièce
  const searchPieceTypePiece = (inputValue) => {
    //const inputValue = e.target.value
    setSearchValue(inputValue)
    setClearInput(false)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    // Traitement du nom tappé dans le formulaire et enregistrement de la suggestion
    if (inputValue !== '' && inputValue !== null) {
      const matchingValue = String(
        suggestion.find((name) => name.toLowerCase().startsWith(inputValue.toLowerCase()))
      ).toLowerCase()
      if (matchingValue !== 'undefined' && matchingValue !== null) {
        const prefix = inputValue
        const suffix = matchingValue.slice(inputValue.length)
        setMatch([prefix, suffix])
      } else {
        setMatch([])
      }
    } else {
      setMatch([])
    }

    searchTypePiece(inputValue)
  }

  // Autocompletion de la suggestion en appuyant sur Tab ou sur Entrer
  const autocompleteOnKeyDown = (e) => {
    if (
      (e.code === 'Tab' || e.code === 'Enter' || e.code === 'ArrowRight') &&
      match &&
      match.length !== 0
    ) {
      e.preventDefault()
      e.target.value = match.join('').toLowerCase()
      searchPieceTypePiece(e.target.value)
      setMatch([])
    }
  }

  // composant de la recherche de pièce par nom pièce
  const renderFormSearchPieceAutocomplete = () => {
    if (demandeId && data?.clientDemandeEtape && data?.clientDemandeEtape?.id !== 1) {
      return null
    }
    return (
      <SearchPiece
        inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
        placeholder={'Recherche pièce'}
        onChange={(e) => searchPieceTypePiece(e.target.value)}
        onKeyDown={(e) => autocompleteOnKeyDown(e)}
        resultatPiece={pieceTypePiece}
        disabled={isTous || disableInput || handleCentreSelectValue(immatsArray)?.length === 0}
        value={searchValue}
        match={match}
        setMatch={setMatch}
        setSearchValue={setSearchValue}
        handleInitialEdit={handleInitialEdit}
        pieceSpinner={pieceSpinner}
        resultShowPiece={resultShowPiece}
        clearInput={clearInput}
        selectedSearchValue=''
        showPieceHn={true}
        onSelect={async (pieceTypePiece) => {
          if (!pieceTypePiece) return
          //verification du piece autorisé  au client professionnel ou pas
          if (pieceTypePiece?.venteReserveePro) {
            if (!isProfessionnel) {
              toast.error('la pièce est autorisée uniquement au client professionnel')
              return
            }
          }

          const updatedPieces = pieces
          let check
          let isHorNorm = false
          const pieceNm = pieceTypePiece.nom
          if (pieceTypePiece?.horsNom) {
            isHorNorm = true
            check = pieces.some(
              (item) => item.typePieceHn == pieceNm.trim() && item.immat == immatSelected
            )
          } else {
            check = pieces.some(
              (item) => item.idTypePiece == pieceTypePiece.id && item.immat == immatSelected
            )
          }

          if (!check) {
            const marque = dataImmatSelected?.sImmatriculationSiv
              ? dataImmatSelected?.stecMarque == ''
                ? dataImmatSelected.smarque
                : dataImmatSelected.stecMarque
              : dataImmatSelected?.marque?.nom
            const modele = dataImmatSelected?.sImmatriculationSiv
              ? dataImmatSelected?.stecModele == ''
                ? dataImmatSelected.smodele
                : dataImmatSelected.stecModele
              : dataImmatSelected?.nom
            const typePieceHnContent = pieceTypePiece?.horsNom ? pieceNm.trim() : null
            if (idTypePieceEdit || typePieceEditHn) {
              const contentIdP = pieceTypePiece?.id ?? null
              const contentNomPc = pieceTypePiece?.id ? pieceTypePiece?.nom : null
              const matchKey = idTypePieceEdit ? 'idTypePiece' : 'typePieceHn'
              const matchValue = idTypePieceEdit || typePieceEditHn
              const updatedKeySetter = idTypePieceEdit ? setIdTypePieceEdit : setTypePieceEditHn
              updatedKeySetter(idTypePieceEdit ? pieceTypePiece?.id : pieceTypePiece?.nom)
              const updatedList = updatedPieces.map((p) => {
                if (p[matchKey] === matchValue) {
                  return {
                    ...p,
                    nomTypePiece: contentNomPc,
                    idTypePiece: contentIdP,
                    typePiece: pieceTypePiece,
                    typePieceHn: typePieceHnContent,
                  }
                }
                return p
              })
              setPieces(updatedList)
              piecesRef.current = updatedList
            } else {
              //trouver le centre de l'immat selectionner :
              const checkImmatCentre = immatsArray.filter((i) => i.value === immatSelected)
              const centreImmatId = checkImmatCentre[0].centreId ?? ''
              const centreImmatLabel = checkImmatCentre[0].centreLabel ?? ''

              const newPiece = {
                ...modeleDemandePieceInitValues,
                idTypePiece: pieceTypePiece.id,
                stock: 'chargement',
                nomTypePiece: pieceTypePiece.nom,
                immat: immatSelected,
                typePiece: pieceTypePiece,
                marque: marque,
                modele: modele,
                typePieceHn: typePieceHnContent,
                immatriculationNonTrouvee: dataImmatSelected?.immatriculationNonTrouvee,
                centre: {
                  nom: centreImmatLabel,
                  id: centreImmatId,
                },
                refConst: '',
              }

              updatedPieces.push(newPiece)
              setPieces([...updatedPieces])
              piecesRef.current = updatedPieces
            }

            setClearInput(true)
            setMatch([]) // Nettoyage du champ d'autocompletion apres la selection
            let stockValue = 0
            let isHorstType = immatSelected.includes('[VHT]')
            if (pieceTypePiece.id)
              await getTypePieceStockValue(
                pieceTypePiece.id,
                '',
                isHorstType ? '' : marque,
                isHorstType ? '' : modele
              ).then((res) => (stockValue = res?.data[0]))
            const piecesWithStock = piecesRef.current.map((p) => {
              if (p.idTypePiece === pieceTypePiece.id && p.immat === immatSelected) {
                return {...p, stock: stockValue}
              }
              return p
            })
            setPieces([...piecesWithStock])

            if (idTypePieceEdit || typePieceEditHn) {
              const pieceEdit = piecesRef.current.find((piece) => {
                return pieceTypePiece?.id
                  ? piece?.idTypePiece === pieceTypePiece?.id && piece?.immat === immatSelected
                  : pieceTypePiece?.nom
                  ? piece?.typePieceHn === pieceTypePiece?.nom && piece?.immat === immatSelected
                  : false
              })
              //mise à jour d'immat selectionner :
              setImmatPieces((prevImmat) => {
                const updatedImmatPieces = {...prevImmat}
                const updatedPieceArr = updatedImmatPieces[immatSelected]
                if (!updatedPieceArr) return prevImmat // sécurité : immat non trouvée
                let immatUpdate: any = []
                immatUpdate = updatedPieceArr.map((immatPiece) => {
                  if (
                    (idTypePieceEdit && immatPiece?.idTypePiece === idTypePieceEdit) ||
                    (typePieceEditHn && immatPiece?.typePieceHn === typePieceEditHn)
                  ) {
                    if (immatPiece?.immat === immatSelected) {
                      return pieceEdit
                    }
                  }
                  return immatPiece
                })
                updatedImmatPieces[immatSelected] = immatUpdate
                return updatedImmatPieces
              })
            } else {
              // appel à la fonction de mise à jour des pièces et des immats
              addPiecesToImmat(immatSelected, pieces?.at(-1), dataImmatSelected, isHorNorm)
            }
          } else {
            setSearchValue('')
            setMatch([])
            toast.error('Pièce déjà ajoutée au véhicule')
          }
        }}
      />
    )
  }

  // composant de la recherche de pièce par le référence constructeur
  const renderFormSearchRefConstructAutocomplete = () => {
    if (demandeId && data?.clientDemandeEtape && data?.clientDemandeEtape?.id !== 1) {
      return null
    }
    return (
      <AutoCompleteRefConst
        placeholder={'Recherche Ref. Constructeur'}
        onChange={(e) => setRefConst(e.target.value)}
        valueRefConst={refConst}
        resultat={pieceRefConst}
        disabled={isTous || disableInput}
        resultShow={resultShow}
        setRefConst={setRefConst}
        clearInput={clearInput}
        onSelect={async (piece) => {
          const updatedPieces = pieces
          let check
          let isHorNorm = false
          if (piece?.horsNom) {
            isHorNorm = true
            check = pieces.some(
              (item) => item?.typePieceHn == piece?.nom && item?.immat == immatSelected
            )
          } else {
            check = pieces.some(
              (item) => item.idTypePiece == piece.id && item.immat == immatSelected
            )
          }

          if (!check) {
            const marque = dataImmatSelected?.sImmatriculationSiv
              ? dataImmatSelected?.stecMarque == ''
                ? dataImmatSelected.smarque
                : dataImmatSelected.stecMarque
              : dataImmatSelected?.marque?.nom
            const modele = dataImmatSelected?.sImmatriculationSiv
              ? dataImmatSelected?.stecModele == ''
                ? dataImmatSelected.smodele
                : dataImmatSelected.stecModele
              : dataImmatSelected?.nom
            const reference = piece.referenceConstructeur
            updatedPieces.push(
              Object.assign(
                {...modeleDemandePieceInitValues},
                {
                  idTypePiece: piece.typePiece.id,
                  stock: 'chargement',
                  nomTypePiece: piece.typePiece.nom,
                  immat: immatSelected,
                  typePiece: piece.typePiece,
                  refConst: piece.referenceConstructeur,
                  marque: marque,
                  modele: modele,
                  typePieceHn: piece?.horsNom ? piece?.nom : null,
                }
              )
            )
            // appel à la fonction de mise à jour des pièces et des immats
            addPiecesToImmat(immatSelected, pieces?.at(-1), dataImmatSelected, isHorNorm)
            setPieces([...updatedPieces])
            let stockValue = 0
            let ref = piece.referenceConstructeur ?? ''
            let marqueValue = marque ?? ''
            let modeleValue = modele ?? ''
            await getTypePieceStockValue(piece.typePiece.id, ref, marqueValue, modeleValue).then(
              (res) => (stockValue = res?.data[0])
            )
            const piecesWithStock = updatedPieces.map((p) => {
              if (p.idTypePiece === piece.typePiece.id && p.immat === immatSelected) {
                return {...p, stock: stockValue}
              }
              return p
            })
            setPieces([...piecesWithStock])
          } else {
            toast.error('Pièce déjà ajoutée au véhicule')
          }
          setClearInput(true)
        }}
      />
    )
  }

  // gestion recherche de pièce par référence constructeur
  const searchPieceRefConst = (e) => {
    e.preventDefault()
    setLoadingSearchRefConst(true)
    setClearInput(false)
    setSearchValue(e.target.value)
    getSearchPieceRefConst(refConst)
      .then((piecesRefConst) => {
        if (piecesRefConst?.status === 200) {
          if (piecesRefConst?.data !== undefined) {
            setResultShow(true)
            setPieceRefConst(piecesRefConst.data)
            setLoadingSearchRefConst(false)
          }
        }
      })
      .catch(() => {
        console.error('Erreur')
      })
  }

  const handleCancelDemande = () => {
    Swal.fire({
      title: 'Attention',
      text: 'Annuler la modification?',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        navigate(
          redirectToClientDemande
            ? clientDemandePath
            : !lState?.demandeId
            ? DemandeListPath
            : `/demandes/${idClient}/traitement/${demandeId}`,
          {
            state: {showCancelToast: true},
          }
        )
      }
    })
  }

  useEffect(() => {
    if (immatPieceCallbackRef.current) {
      immatPieceCallbackRef.current(immatPieces)
      immatPieceCallbackRef.current = null
    }
  }, [immatPieces])

  // useEffect de récupération du site au changement de l'immat selectionné
  useEffect(() => {
    // Si immatsArray a des valeurs
    if (immatsArray?.length > 0) {
      const siteValue = immatsArray?.find((item) => item?.value === immatSelected)?.site
        ? immatsArray?.find((item) => item?.value === immatSelected)?.site?.toString()
        : null
      setSiteSelected(siteValue)
    }
  }, [immatSelected, immatsArray])

  const handleChangeImmatSel = (e) => {
    setImmatSelected(e.target.value)
    setImmatPieceEdit(e.target.value)
    if (e.target.value != 'Tous') {
      let objImmat: any = []
      if (e.target.value.includes('-')) {
        // Récupérer le véhicule par marque et modèle ou VHT
        const str = e.target.value.split(' - ')
        const marque = str[0]
        const modele = str.slice(1).join(' - ')
        if (modele.includes('[VHT]')) {
          objImmat = dataImmatArr.filter((i) => i.id + ' [VHT]' === e.target.value)
        } else {
          objImmat = dataImmatArr.filter((i) => i.marque?.nom === marque && i.nom === modele)
        }
      } else {
        objImmat = dataImmatArr.filter((i) => i.sImmatriculationSiv === e.target.value)
      }
      setDataImmatSelected(objImmat[0])
      if (idTypePieceEdit || typePieceEditHn) {
        let pieceTrouvee
        if (idTypePieceEdit) {
          pieceTrouvee = pieces.find(
            (piece) => piece.idTypePiece === idTypePieceEdit && piece.immat === immatSelected
          )
        } else if (typePieceEditHn) {
          pieceTrouvee = pieces.find(
            (piece) => piece.typePieceHn === typePieceEditHn && piece.immat === immatSelected
          )
        }
        const objetImmat = objImmat[0]
        const immatTrouvee = pieceTrouvee?.immat
        let immatChecked = ''
        if (objetImmat?.sImmatriculationSiv) {
          immatChecked = objetImmat?.sImmatriculationSiv
        } else if (objetImmat?.nom) {
          immatChecked = objetImmat?.marque?.nom + ' - ' + objetImmat?.nom
          if (objetImmat?.isHorsType) immatChecked = objetImmat?.id + ' [VHT]'
        }

        const marque = objetImmat?.sImmatriculationSiv
          ? objetImmat?.stecMarque == ''
            ? objetImmat.smarque
            : objetImmat.stecMarque
          : objetImmat?.marque?.nom
        const modele = objetImmat?.sImmatriculationSiv
          ? objetImmat?.stecModele == ''
            ? objetImmat.smodele
            : objetImmat.stecModele
          : objetImmat?.isHorsType
          ? objetImmat?.nom + ' [VHT]'
          : objetImmat?.nom

        if (immatTrouvee !== immatChecked) {
          //get clientDemandeImmat d'immat checked
          let pieceImmatCheked = pieces.find((piece) => piece.immat === immatChecked)
          let newCLientDemandeImmat = pieceImmatCheked?.clientDemandeImmat

          //debut de la mise à jour du pièce
          let piecesUp: any = {}

          // Vérifie si la pièce existe déjà
          let alreadyExists: any = {}
          if (idTypePieceEdit) {
            alreadyExists = pieces.some(
              (piece) => piece?.idTypePiece === idTypePieceEdit && piece.immat === immatChecked
            )
          } else if (typePieceEditHn) {
            alreadyExists = pieces.some(
              (piece) => piece?.typePieceHn === typePieceEditHn && piece.immat === immatChecked
            )
          }

          if (!alreadyExists) {
            if (idTypePieceEdit) {
              piecesUp = pieces.map((p) => {
                if (p.idTypePiece === idTypePieceEdit && p.immat === immatTrouvee) {
                  return {
                    ...p,
                    clientDemandeImmat: newCLientDemandeImmat,
                    immat: immatChecked,
                    marque: marque,
                    modele: modele,
                  }
                }
                return p
              })
            } else if (typePieceEditHn) {
              piecesUp = pieces.map((p) => {
                if (p.typePieceHn === typePieceEditHn && p.immat === immatTrouvee) {
                  return {
                    ...p,
                    clientDemandeImmat: newCLientDemandeImmat,
                    immat: immatChecked,
                    marque: marque,
                    modele: modele,
                  }
                }
                return p
              })
            }
            setPieces(piecesUp)
          } else {
            toast.error('Pièce déjà ajoutée au véhicule')
            return
          }
          //fin de la mise à jour du pièce

          //debut mise à jour de l'immat
          let newPieceEdit: any = {}
          if (idTypePieceEdit) {
            newPieceEdit = piecesUp.filter(
              (piece) =>
                piece.idTypePiece === pieceTrouvee.idTypePiece && piece.immat === immatChecked
            )
          } else if (typePieceEditHn) {
            newPieceEdit = piecesUp.filter(
              (piece) =>
                piece.typePieceHn === pieceTrouvee.typePieceHn && piece.immat === immatChecked
            )
          }

          const immatNewPieceEdit = newPieceEdit[0]?.immat
          const immatPieceTrouvee = pieceTrouvee?.immat
          const idPieceTrouvee = pieceTrouvee?.idTypePiece
          const typePieceHnTrouvee = pieceTrouvee?.typePieceHn

          //efface l'immat dans l'ancien:
          setImmatPieces((prevImmat) => {
            const updatedImmatPieces = {...prevImmat}
            const updatedPieceArr = updatedImmatPieces[immatPieceTrouvee]?.filter((piece) => {
              if (idTypePieceEdit) {
                return piece?.idTypePiece !== idPieceTrouvee
              } else if (typePieceEditHn) {
                return piece?.typePieceHn !== typePieceHnTrouvee
              }
            })
            if (updatedPieceArr !== undefined) {
              updatedImmatPieces[immatPieceTrouvee] = updatedPieceArr
            }
            return updatedImmatPieces
          })

          //ajout du nouveau piece dans le nouveau immat selectionner
          immatPieceCallbackRef.current = () => {
            setImmatPieces((prevImmat) => {
              const updatedImmatPieces = {...prevImmat}
              const existingPieces = updatedImmatPieces[immatNewPieceEdit] || []
              updatedImmatPieces[immatNewPieceEdit] = [...existingPieces, newPieceEdit[0]]
              return updatedImmatPieces
            })
          }
          //fin de la mise à jour de l'immat
        }
        setSearchValue('')
        setIdTypePieceEdit(undefined)
        setTypePieceEditHn('')
      }
      setIsTous(false)
    } else {
      setSearchValue('')
      setTypePieceEditHn('')
      setIdTypePieceEdit(undefined)
      setIsTous(true)
      setMatch([])
    }
  }

  const handleAddImmat = async (immat, selected, demandeSource) => {
    setDemandeSourceValue(demandeSource)
    if (immat) {
      const id = toast.loading('Recherche du véhicule en cours...')
      toastId.current = id
      allowAddCentre = true

      const result = await verifyCatdata(selected ?? immat)

      // Afficher la bonne réponse
      if (result.status === 'success') {
        toast.update(id, {
          render: 'Véhicule identifié',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      } else if (result.status === 'not_found') {
        toast.update(id, {
          render: 'Véhicule non identifié',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      } else {
        toast.update(id, {
          render: 'Erreur lors de la vérification',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }

      toastId.current = undefined
      ajouterImmat(immat)

      // MAJ des pièces liées au nouveau véhicule après changement de ce dernier
      setImmatPieces({})
      setPieces([])
      // Fin MAJ
    } else {
      setInfoModele([selected])
      setInfoModeleArr([selected])
      setDataImmatArr([selected])
      setDataImmatSelected(selected)
      setImmatriculation(selected)
      const marque = selected?.marque?.nom
      const modele = selected?.nom
      const vht = selected?.isHorsType ? ' [VHT]' : ''
      addImmat({
        value: marque + ' - ' + modele + vht,
        label: marque + ' - ' + modele + vht,
        centreLabel: '',
        centreId: '',
        marque: marque,
        modele: modele,
        id: selected?.id,
        isHorsType: selected?.isHorsType,
        immatriculationNonTrouvee: selected?.immatriculationNonTrouvee,
        vin: selected?.sVin,
        datePme: selected.datePme,
        site: selected?.site ?? null,
      })
      setSiteSelected(selected?.site ?? null)
      const inModIdArr = modeleIdArr.find((m) => m.id === selected.id)
      if (!inModIdArr) {
        setModeleIdArr([{[selected.id]: marque + ' - ' + modele}])
        if (selected?.isHorsType) setDataHorsType([...dataHorsType, selected])
      }

      const prevState = lState || {dataVehicle: {}}

      const dataVehicleMap = {
        // ...prevState.dataVehicle,
        [selected.id]: selected,
      }
      let newIndex = selected.marque.nom + ' - ' + selected.nom
      if (selected?.isHorsType) newIndex += ' [VHT]'

      setImmatPieces(prev => {
        const ancienneCle = Object.keys(prev)[0]
        const valeur = prev[ancienneCle]

        return {
          [newIndex]: valeur
        }
      })

      // MAJ des pièces liées au nouveau véhicule après changement de ce dernier
      setImmatPieces({})
      setPieces([])
      setImmatCentre({[selected.id] : null})
      // Fin MAJ

      navigate('.', {
        replace: true,
        state: {
          ...prevState,
          immat: prevState.immat ?? [], // ne change rien ici
          dataVehicle: dataVehicleMap,
        },
      })
    }
  }

  // Gestion des véhicules hors types (modification des détails)
  const handleDataHorsType = (id: string, newObject: any) => {
    if (newObject) {
      // Mise à jour des infos dans le tableau des véhicules hors type
      setDataHorsType((prevD) => prevD.map((d) => (d.id === id ? newObject : d)))

      // Mise à jour des infos à afficher sur les détails de vahicule
      setInfoModeleArr((prevI) => prevI.map((i) => (i.id === id ? newObject : i)))

      // Mise à jour du tableu immatsArray pour les affichages et le traitement
      const mq = newObject.marque?.nom ?? ''
      const md = newObject?.nom ?? ''
      const label = mq + ' - ' + md
      updateVHT(id, {label: label, marque: mq, modele: md})

      // Mise à jour des données affichées en temps réel
      setInfoModele([newObject])

      // Mise à jour des données de véhicule à afficher dans les lignes des pièces
      setPieces((prevP) =>
        prevP.map((p) => {
          if (p.immat === id + ' [VHT]') {
            return {
              ...p,
              marque: newObject.marque?.nom,
              modele: newObject.nom,
            }
          }
          return p
        })
      )

      // Mise à jour des données de pièces envoyées au backend
      setImmatPieces((prevData) => {
        const vhtKey = id + ' [VHT]'
        if (prevData[vhtKey]) {
          return {
            ...prevData,
            [vhtKey]: prevData[vhtKey].map((ip) => ({
              ...ip,
              marque: newObject.marque?.nom,
              modele: newObject.nom,
            })),
          }
        }
        return prevData
      })
    }
  }

  const handleCentreSelectValue = (immatsArray) => {
    // Contiendra la liste des immat filtré par le centre de l'utilisateur connecté
    let filteredImmatsArray: {value: string; label: string; centre: number; centreId: number}[] = []

    // Si l'utilisateur connecté à au moins 1 centre affecté
    if (userConnected?.currentUser?.listeCentres?.[0].length !== 0) {
      filteredImmatsArray = [...immatsArray]
      filteredImmatsArray = filteredImmatsArray.filter((immat) => {
        return userConnected?.currentUser?.listeCentres?.[0]?.some((centre) => {
          return (
            (immat.hasOwnProperty('centre') && immat?.centre === centre?.id) ||
            (immat.hasOwnProperty('centreId') && immat?.centreId === centre?.id)
          )
        })
      })
    } else {
      filteredImmatsArray = [...immatsArray]
    }

    // Contiendra la liste des immat formatté avec le tableau d'immat filtré
    let result: {value: string; label: string}[] = []

    // Ajout de "Tous" pour tout afficher
    if (filteredImmatsArray.length > 1) {
      result = [{value: 'Tous', label: 'Tous'}, ...filteredImmatsArray]
    } else if (filteredImmatsArray.length === 1) {
      result = filteredImmatsArray
    }

    return result
  }

  useEffect(() => {
    pieces.forEach((piece) => {
      if (piece?.stock === 'chargement') {
        setStockLoading(true)
      } else {
        setStockLoading(false)
      }
    })
  }, [pieces])

  useEffect(() => {
    // Ne plus récupérer les données clients, elles sont déjà passées en props
    // getOneClientData()
    getAllClientAdresses()
    // if (demandeId) {
    //   getClientDataOthers()
    // }
  }, [idClient, demandeId])

  const refPopupAutoClient = useRef<any>(null)

  useEffect(() => {
    if (panierValue?.length > 0) setPanierAriane(panierValue)
    if (clientDemande) setDemandeAriane(clientDemande)
    else resetFilAriane()

    const etape = clientDemande?.clientDemandeEtape?.code
    if (!etape) return

    setEtape(etape)

    if (clientDemande?.intervention) setStatut('INTERVENTION')
    else if (etape === 'REFUS') setStatut('REFUSE')
    else if (etape === 'BLOQU') setStatut('ACCEPTEE BLOQUE')
    else if (etape === 'MODIF') setStatut('MODIFIEE')
    else setStatut('')

    if (clientDemande && !refPopupAutoClient.current) {
      refPopupAutoClient.current = clientDemande
      // Si changeClient est true (Besoin de changer client - Incompatibilité du site client / demande)
      if (clientDemande?.changeClient) {
        const modalElement = document.getElementById('exampleModalToggle')
        if (modalElement) {
          const modal = Modal.getOrCreateInstance(modalElement)
          modal.show()
        }
      }
    }
  }, [panierValue, clientDemande])

  const getDemandeProp = useCallback(() => {
    getDemandeProposee(demandeId).then((clientDemandeProp) => {
      if (clientDemandeProp?.status == 200 && clientDemandeProp?.data != undefined) {
        const finalPanier = clientDemandeProp?.data?.map((piece) => {
          // TVA POT toujours 20%
          const isProfessionnel = piece?.isTypePiecePOT
            ? 20
            : dataClientInfos && dataClientInfos?.professionnel === false
            ? 10
            : 20

          const pieceExclue = !!dataClientInfos?.sauf?.some(
            (item) => item.label === piece.nomTypePieceProposee
          )
          const fraisOffert = !!dataClientInfos?.fraisPortOffert && !pieceExclue
          const fraisDePort = fraisOffert || retraitDepot ? 0 : Number(piece?.fraisDePort)

          const taux = Number(piece?.tauxRemise ?? 0)
          const tauxTva = Number(piece?.tauxTva ?? 0)
          const prix = Number(piece.prix ?? 0)

          const prixReferentielTtc = Number(prix * (1 + tauxTva / 100)) ?? 0
          const prixReferentielHtInitial =
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0
          const prixReferentielHt =
            Number(piece?.prixReferentiel) ??
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ??
            0

          const prixVenteProposeeHt =
            Number(prixReferentielHt - prixReferentielHt * (taux / 100)) ?? 0
          const prixVenteProposeeTtc =
            Number(prixVenteProposeeHt * (1 + isProfessionnel / 100)) ?? 0
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

          return {
            ...piece,
            fraisDePort: Number(fraisDePort?.toFixed(2)),
            montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
            prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
            prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
            prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
            prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
            prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
          }
        })
        setPanierValue(finalPanier)
      }
    })
  }, [demandeId])

  useEffect(() => {
    if (demandeId && dataClientInfos) {
      getDemandeProp()
    }
  }, [demandeId, dataClientInfos])

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className=''>
          {!immatriculationValide ? (
            <LoadingData />
          ) : (
            <>
              {/* debut information client */}
              {loadingDataCLient ? (
                <div className={'card mb-2'}>
                  <LoadingData />
                </div>
              ) : (
                <div className={'card mb-2'}>
                  <ClientInfos
                    clientData={dataClient}
                    demandeId={demandeId}
                    otherData={demandeId != null ? otherData : 0}
                    loadingCLientInfo={null}
                    isProspect={null}
                    clientAdresses={clientAdresses}
                    contactedBy={contactedByDm}
                    isEdit={isEdit}
                    clientDemandeStatus={clientDemandeStatus ?? ''}
                    setClientAdresseEdit={setClientAdresseEdit}
                    refetchClientData={refetchClientData}
                    setRefetchClientData={setRefetchClientData}
                  />
                  {/*Affichage "Plus d'informations"*/}
                  <ClientMoreInfos
                    otherData={otherData}
                    demandeId={demandeId}
                    radioValue={radioValue ?? lState?.radioValue}
                    contentCommunication={
                      contentCommunication?.trim()?.length > 0
                        ? contentCommunication
                        : lState?.contentCommunication
                    }
                    demandeClient={clientDemande}
                    clientData={dataClient}
                    isConfirmEdit={isConfirmEdit}
                    contactedBy={contactedByDm}
                    contactedByBloc={contactedByBloc}
                    setContactedByBloc={setContactedByBloc}
                    showMoreClientInfo={showMoreClientInfo}
                    setShowMoreClientInfo={setShowMoreClientInfo}
                  />
                  <AdresseClient
                    // demandeId={demandeId}
                    clientData={dataClient}
                    // otherData={demandeId != null ? otherData : 0}
                    clientAdresses={clientAdresses}
                    contactedBy={contactedByDm}
                    contentCommunication={lState?.contentCommunication ?? contentCommunication}
                    radioValue={lState?.radioValue}
                    updatedAdresseLivInfo={updatedAdresseLivInfo}
                    setUpdatedAdresseLivInfo={setUpdatedAdresseLivInfo}
                    updatedAdresseFactInfo={updatedAdresseFactInfo}
                    setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
                    isAdresseUpdated={isAdresseUpdated}
                    setIsAdresseUpdated={setIsAdresseUpdated}
                    // isConfirmEdit={isConfirmEdit}
                    fromDemandeForm={true}
                    isCreateOrUpdate={true}
                    retraitDepot={retraitDepot}
                    setRetraitDepot={setRetraitDepot}
                    setClientAdresseEdit={setClientAdresseEdit}
                    livraisonSelectedValue={livraisonSelectedValue}
                    setLivraisonSelectedValue={setLivraisonSelectedValue}
                    facturationSelectedValue={facturationSelectedValue}
                    setFacturationSelectedValue={setFacturationSelectedValue}
                    clientAdresseData={clientAdresseData}
                  />
                </div>
              )}
              {/* fin information client */}
              <div className={'card p-5 mb-2'}>
                {/* debut information vehicule */}
                <div className='mb-10 rounded-1'>
                  <>
                    <div className='card-title mb-4 d-flex justify-content-between align-items-center'>
                      <h3 className='fw-bolder m-0'>Liste des véhicules</h3>
                      {/*{shouldDisplayFonctionnalite(currentUser, 'AJOUTER SECOND VEHICULE') && (*/}
                      {/*  <div*/}
                      {/*    data-tooltip-id='add-tooltip'*/}
                      {/*    data-tooltip-content='Ajouter un véhicule'*/}
                      {/*    data-tooltip-place='bottom'*/}
                      {/*  >*/}
                      {/*    {!(demandeId && !immatValide) && (*/}
                      {/*      <button*/}
                      {/*        type='button'*/}
                      {/*        className='btn btn-sm btn-light-primary'*/}
                      {/*        data-bs-target='#exampleModalSearchV'*/}
                      {/*        data-bs-toggle='modal'*/}
                      {/*      >*/}
                      {/*        <KTIcon iconName='plus' className='fs-1' />*/}
                      {/*      </button>*/}
                      {/*    )}*/}
                      {/*  </div>*/}
                      {/*)}*/}
                    </div>
                    <div className={'row'}>
                      <div className={`col-lg-${showDetailVehicule ? '6' : '12'} `}>
                        <div className='table-responsive'>
                          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                              <tr className='fw-bold text-muted text-center'>
                                <th className='min-w-100px'>Immatriculation</th>
                                <th className='min-w-100px'>Centre</th>
                                <th className='min-w-100px'>Marque</th>
                                <th className='min-w-100px'>Modèle</th>
                                <th className='min-w-100px'>Date 1ère circulation</th>
                                <th className='min-w-100px'>VIN</th>
                                <th className='min-w-100px'>Actions</th>
                              </tr>
                            </thead>
                            <tbody className='text-center min-height'>{renderImmatTable()}</tbody>
                          </table>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        {showDetailVehicule && (
                          <>
                            <VehicleData
                              immatriculation={immatriculation}
                              vehicleInfo={vehicleInfo}
                              closeBtn={true}
                              infoModele={infoModele}
                              isEditable={infoModele[0]?.isHorsType}
                              setData={handleDataHorsType}
                              setShowDetailVehicule={setShowDetailVehicule}
                              showDetailVehicule={showDetailVehicule}
                              loading={loading}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </>
                </div>
                {/* fin information vehicule */}

                {/* debut recherche pièce */}
                <div className='mb-10 rounded-1'>
                  <>
                    <div style={immatriculationValide ? {} : {display: 'none'}}>
                      <div className='card-title mb-4 mt-5'>
                        <h3 className='fw-bolder m-0'>Recherche de pièces</h3>
                      </div>

                      <div className='row mb-6'>
                        <div className='col-md-3 mb-4'>
                          <SelectInput
                            fieldName={'idCentre'}
                            inputClassName={'form-select form-select-solid form-select-lg fw-bold'}
                            options={handleCentreSelectValue(immatsArray)}
                            formik={formik}
                            onChange={(e) => handleChangeImmatSel(e)}
                            disabled={disableImmatSelect}
                            selectedDefault={immatSelected}
                          />
                        </div>
                        <div className='col-md-5 mb-4'>{renderFormSearchPieceAutocomplete()}</div>
                        <div className='col mb-4 d-flex'>
                          {renderFormSearchRefConstructAutocomplete()}
                          <button
                            className='btn btn-info'
                            disabled={refConst.length == 0 || isTous}
                            onClick={(e) => searchPieceRefConst(e)}
                            style={{
                              borderRadius: '0 5px 5px 0',
                            }}
                          >
                            {!loadingSearchRefConst ? (
                              <i className='bi bi-search fs-2'></i>
                            ) : (
                              <span className='indicator-progress' style={{display: 'block'}}>
                                <span
                                  className='spinner-border spinner-border-sm align-middle w-20px h-20px'
                                  style={{
                                    marginBottom: '2px',
                                  }}
                                ></span>
                              </span>
                            )}
                          </button>
                        </div>
                        {isTous && (
                          <div className='d-flex gap-2 mb-2 mx-3 align-items-center'>
                            <i className='bi bi-info-square text-warning'></i>
                            <span className={'text-warning'}>
                              Veuillez sélectionner un véhicule dans la liste pour rechercher une
                              pièce!
                            </span>
                          </div>
                        )}
                        <div className='table-responsive'>
                          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                              <tr className='fw-bold text-muted'>
                                <th className='min-w-150px fs-6'>Référence pièce</th>
                                <th className='min-w-120px fs-6'>Immatriculation</th>
                                <th className='min-w-150px fs-6'>Marque / Modele</th>
                                <th className='min-w-150px fs-6'>Commentaire</th>
                                <th className='min-w-150px fs-6'>Référence OE</th>
                                <th className='fs-6'>Quantité</th>
                                <th className='min-w-50px fs-6'>Stock</th>
                                <th className='min-w-50px text-end fs-6'>Actions</th>
                              </tr>
                            </thead>
                            <tbody className={'min-height'}>{renderPiecesTable()}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className='card-footer d-flex flex-column py-6 px-9 gap-5'>
                      <div className='d-flex flex-row justify-content-end gap-5'>
                        {!lState?.demandeId && (
                          <button
                            type='button'
                            className='btn'
                            style={{
                              backgroundColor: isHovered ? '#8ac376' : '#9fd48c',
                              borderColor: isHovered ? '#8ac376' : '#9fd48c',
                              color: '#ffffff',
                              transition: 'background-color 0.2s ease, border-color 0.2s ease',
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            data-bs-target={!selectedEquipe ? '#choixEquipeModal' : null}
                            data-bs-toggle={!selectedEquipe ? 'modal' : null}
                            disabled={
                              loadingOnSave ||
                              loadingOnSaveAndDupl ||
                              stockLoading ||
                              Object.keys(immatPieces).length == 0
                            }
                            onClick={() =>
                              !selectedEquipe ? setIsDuplicateButton(true) : SubmitDemande(true)
                            }
                          >
                            {!loadingOnSaveAndDupl && 'Confirmer et créer une nouvelle'}
                            {loadingOnSaveAndDupl && (
                              <span className='indicator-progress' style={{display: 'block'}}>
                                Confirmation de la demande...{' '}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            )}
                          </button>
                        )}
                        <button
                          type='button'
                          className='btn btn-light'
                          onClick={() => handleCancelDemande()}
                        >
                          Annuler
                        </button>
                        {/* Si il n'y a pas d'équipe selectionnée */}
                        {/* Aggir comme un bouton d'affichage de modal */}
                        {/* Sinon bouton de soumission */}
                        <button
                          type={!selectedEquipe ? 'button' : 'submit'}
                          className='btn btn-primary'
                          data-bs-target={!selectedEquipe ? '#choixEquipeModal' : null}
                          data-bs-toggle={!selectedEquipe ? 'modal' : null}
                          disabled={
                            loadingOnSave ||
                            loadingOnSaveAndDupl ||
                            stockLoading ||
                            Object.keys(immatPieces).length == 0
                          }
                          onClick={() =>
                            !selectedEquipe ? setIsDuplicateButton(false) : SubmitDemande(false)
                          }
                        >
                          {!loadingOnSave &&
                            (shouldDisplayFonctionnalite(currentUser, 'CREER ET TRAITER DEMANDE') &&
                            !lState?.demandeId
                              ? 'Créer et traiter une demande'
                              : 'Confirmer')}
                          {loadingOnSave && (
                            <span className='indicator-progress' style={{display: 'block'}}>
                              {shouldDisplayFonctionnalite(
                                currentUser,
                                'CREER ET TRAITER DEMANDE'
                              ) && !lState?.demandeId
                                ? 'Création '
                                : 'Confirmation '}{' '}
                              de la demande...{' '}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </button>
                        {/* Si il n'y a pas d'équipe selectionnée */}
                        {/* Aggir comme un bouton d'affichage de modal */}
                        {/* Sinon bouton de soumission */}
                      </div>
                      <div>
                        {showNoPieceOnImmat && (
                          <div className='d-flex gap-2 mb-2 mx-3 align-items-center justify-content-end'>
                            <i className='bi bi-info-square text-warning'></i>
                            <span className={'text-warning'}>
                              Veuillez assigner une pièce au moins pour chaque véhicule!
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                </div>
                {/* fin recherche pièce */}
              </div>
              <div className='card p-5 rounded-1 mb-2'>
                <DemandePj images={images} setImages={setImages} />
              </div>
            </>
          )}

          <ResearchVehicleModal
            clientId={idClient}
            handleSubmit={handleAddImmat}
            demandeSourceValue={demandeSourceValue}
            demandeId={demandeId}
            choicedDemandeSource={demandeSourceValue}
            contentCommunication={contentCommunication}
            labelSearch={searchTerm}
          />

          {/*Modal that display Client researchBar*/}
          <ResearchClientModal
            setClientId={setClientId}
            clientId={clientId}
            setIsClientSociety={setIsClientSociety}
            setIsCreateViaModal={setIsCreateViaModal}
            defaultValueContact={null}
            demandeSources={null}
            sourceLoader={null}
            choicedDemandeSource={demandeSourceValue}
            setChoicedDemandeSource={null}
            transformedSource={null}
            isEdit={isEdit}
            setTempClientId={setTempClientId}
            setTempClient={setTempClient}
            isPrevious={isPrevious}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            demandeClient={clientDemande}
          />

          <TransfertCentreModal
            infoSelected={{idDemande: null, immat: ''}}
            centreSelected={centreSelected}
            centres={centres}
            onCentreChange={handleCentreChange}
            onTransfert={handleTransfert}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />

          {/*modal centre pour les types pièces horsNorme*/}
          <TransfertCentreHnModal
            infoSelected={{idDemande: null, immat: ''}}
            centres={centres}
            onTransfertHn={handleTransfertHn}
            pieceCentreAssign={pieceCentreAssign}
            setPieceCentreAssign={setPieceCentreAssign}
            selectedOptionHn={selectedOptionHn}
            setSelectedOptionHn={setSelectedOptionHn}
          />
        </div>
      </form>
      {/*Affichage du tooltip*/}
      <Tooltip id='tooltip' />

      {/*Modal création de client*/}
      <AddClientModal
        setClientId={setClientId}
        setOpenModalResVeh={setOpenModalResVeh}
        isCreateViaModal={isCreateViaModal}
        openModalResVeh={openModalResVeh}
        fromChangeClient={true}
        setTempClientId={setTempClientId}
      />

      {/*Modal choix de contact client*/}
      <ChoixContactModal
        clientId={clientId}
        setDefaultValueContact={setDefaultValueContact}
        defaultValueContact={defaultValueContact}
        isFromAddClientContact={null}
        setIsFromAddClientContact={null}
        setRadioValue={setRadioValue}
        isClientSociety={isClientSociety}
        isFromClientList={false}
        setContactedBy={setContactedByDm}
        radioValue={radioValue}
        setContentCommunication={setContentCommunication}
        contentCommunication={contentCommunication}
        isDuplicate={isDuplicate}
        setIsDuplicate={setIsDuplicate}
        toggleDuplicate={toggleDuplicate}
        isEdit={isEdit}
        handleUpdateClientData={handleUpdateClientData}
        tempClientId={tempClientId}
        setIsConfirmEdit={setIsConfirmEdit}
        setContactedByBloc={setContactedByBloc}
        demandeId={demandeId}
        setIsPrevious={setIsPrevious}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />

      {/* Modal de modification d'une équipe */}
      <EquipeModal
        setSelectedEquipe={setSelectedEquipe}
        selectedEquipe={selectedEquipe}
        currentPage={verificationIsEdit ? 'modification' : 'creation'}
        action={(equipe) => {
          isDuplicateButton ? SubmitDemande(true, equipe) : SubmitDemande(false, equipe)
        }}
      />

      {/*modal ajout d'adresse pour le client selectionné*/}
      <ClientAdresseFormModal
        clientId={dataClient?.id}
        clientAdresses={clientAdresses}
        setClientAdresses={setClientAdresses}
        clientAdresseEdit={clientAdresseEdit}
        setRefetchClientData={setRefetchClientData}
        setClientAdresseData={setClientAdresseData}
        isFromFicheClient={true}
      />
    </div>
  )
}

export {DemandeForm}
